/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// TinyColor v0.9.16
// https://github.com/bgrins/TinyColor
// 2013-08-10, Brian Grinstead, MIT License
(function () {
  var t = /^[\s,#]+/,
      n = /\s+$/,
      o = 0,
      a = Math,
      A = a.round,
      h = a.min,
      k = a.max,
      j = a.random;function y(J, G) {
    J = J ? J : '';G = G || {};if ((typeof J === 'undefined' ? 'undefined' : _typeof(J)) == 'object' && J.hasOwnProperty('_tc_id')) {
      return J;
    }var L = p(J);var H = L.r,
        K = L.g,
        M = L.b,
        N = L.a,
        I = A(100 * N) / 100,
        O = G.format || L.format;if (H < 1) {
      H = A(H);
    }if (K < 1) {
      K = A(K);
    }if (M < 1) {
      M = A(M);
    }return { ok: L.ok, format: O, _tc_id: o++, alpha: N, getAlpha: function getAlpha() {
        return N;
      }, setAlpha: function setAlpha(P) {
        N = q(P);I = A(100 * N) / 100;
      }, toHsv: function toHsv() {
        var P = s(H, K, M);return { h: P.h * 360, s: P.s, v: P.v, a: N };
      }, toHsvString: function toHsvString() {
        var Q = s(H, K, M);var S = A(Q.h * 360),
            R = A(Q.s * 100),
            P = A(Q.v * 100);return N == 1 ? 'hsv(' + S + ', ' + R + '%, ' + P + '%)' : 'hsva(' + S + ', ' + R + '%, ' + P + '%, ' + I + ')';
      }, toHsl: function toHsl() {
        var P = B(H, K, M);return { h: P.h * 360, s: P.s, l: P.l, a: N };
      }, toHslString: function toHslString() {
        var Q = B(H, K, M);var S = A(Q.h * 360),
            R = A(Q.s * 100),
            P = A(Q.l * 100);return N == 1 ? 'hsl(' + S + ', ' + R + '%, ' + P + '%)' : 'hsla(' + S + ', ' + R + '%, ' + P + '%, ' + I + ')';
      }, toHex: function toHex(P) {
        return z(H, K, M, P);
      }, toHexString: function toHexString(P) {
        return '#' + this.toHex(P);
      }, toHex8: function toHex8() {
        return e(H, K, M, N);
      }, toHex8String: function toHex8String() {
        return '#' + this.toHex8();
      }, toRgb: function toRgb() {
        return { r: A(H), g: A(K), b: A(M), a: N };
      }, toRgbString: function toRgbString() {
        return N == 1 ? 'rgb(' + A(H) + ', ' + A(K) + ', ' + A(M) + ')' : 'rgba(' + A(H) + ', ' + A(K) + ', ' + A(M) + ', ' + I + ')';
      }, toPercentageRgb: function toPercentageRgb() {
        return { r: A(D(H, 255) * 100) + '%', g: A(D(K, 255) * 100) + '%', b: A(D(M, 255) * 100) + '%', a: N };
      }, toPercentageRgbString: function toPercentageRgbString() {
        return N == 1 ? 'rgb(' + A(D(H, 255) * 100) + '%, ' + A(D(K, 255) * 100) + '%, ' + A(D(M, 255) * 100) + '%)' : 'rgba(' + A(D(H, 255) * 100) + '%, ' + A(D(K, 255) * 100) + '%, ' + A(D(M, 255) * 100) + '%, ' + I + ')';
      }, toName: function toName() {
        if (N === 0) {
          return 'transparent';
        }return F[z(H, K, M, true)] || false;
      }, toFilter: function toFilter(S) {
        var T = '#' + e(H, K, M, N);var Q = T;var P = G && G.gradientType ? 'GradientType = 1, ' : '';if (S) {
          var R = y(S);Q = R.toHex8String();
        }return 'progid:DXImageTransform.Microsoft.gradient(' + P + 'startColorstr=' + T + ',endColorstr=' + Q + ')';
      }, toString: function toString(T) {
        var Q = !!T;T = T || this.format;var S = false;var P = !Q && N < 1 && N > 0;var R = P && (T === 'hex' || T === 'hex6' || T === 'hex3' || T === 'name');if (T === 'rgb') {
          S = this.toRgbString();
        }if (T === 'prgb') {
          S = this.toPercentageRgbString();
        }if (T === 'hex' || T === 'hex6') {
          S = this.toHexString();
        }if (T === 'hex3') {
          S = this.toHexString(true);
        }if (T === 'hex8') {
          S = this.toHex8String();
        }if (T === 'name') {
          S = this.toName();
        }if (T === 'hsl') {
          S = this.toHslString();
        }if (T === 'hsv') {
          S = this.toHsvString();
        }if (R) {
          return this.toRgbString();
        }return S || this.toHexString();
      } };
  }y.fromRatio = function (G, J) {
    if ((typeof G === 'undefined' ? 'undefined' : _typeof(G)) == 'object') {
      var H = {};for (var I in G) {
        if (G.hasOwnProperty(I)) {
          if (I === 'a') {
            H[I] = G[I];
          } else {
            H[I] = g(G[I]);
          }
        }
      }G = H;
    }return y(G, J);
  };function p(H) {
    var I = { r: 0, g: 0, b: 0 };var G = 1;var J = false;var K = false;if (typeof H == 'string') {
      H = i(H);
    }if ((typeof H === 'undefined' ? 'undefined' : _typeof(H)) == 'object') {
      if (H.hasOwnProperty('r') && H.hasOwnProperty('g') && H.hasOwnProperty('b')) {
        I = l(H.r, H.g, H.b);J = true;K = String(H.r).substr(-1) === '%' ? 'prgb' : 'rgb';
      } else {
        if (H.hasOwnProperty('h') && H.hasOwnProperty('s') && H.hasOwnProperty('v')) {
          H.s = g(H.s);H.v = g(H.v);I = w(H.h, H.s, H.v);J = true;K = 'hsv';
        } else {
          if (H.hasOwnProperty('h') && H.hasOwnProperty('s') && H.hasOwnProperty('l')) {
            H.s = g(H.s);H.l = g(H.l);I = m(H.h, H.s, H.l);J = true;K = 'hsl';
          }
        }
      }if (H.hasOwnProperty('a')) {
        G = H.a;
      }
    }G = q(G);return { ok: J, format: H.format || K, r: h(255, k(I.r, 0)), g: h(255, k(I.g, 0)), b: h(255, k(I.b, 0)), a: G };
  }function l(I, H, G) {
    return { r: D(I, 255) * 255, g: D(H, 255) * 255, b: D(G, 255) * 255 };
  }function B(G, K, M) {
    G = D(G, 255);K = D(K, 255);M = D(M, 255);var N = k(G, K, M),
        I = h(G, K, M);var J,
        O,
        H = (N + I) / 2;if (N == I) {
      J = O = 0;
    } else {
      var L = N - I;O = H > 0.5 ? L / (2 - N - I) : L / (N + I);switch (N) {case G:
          J = (K - M) / L + (K < M ? 6 : 0);break;case K:
          J = (M - G) / L + 2;break;case M:
          J = (G - K) / L + 4;break;}J /= 6;
    }return { h: J, s: O, l: H };
  }function m(L, O, K) {
    var G, M, N;L = D(L, 360);O = D(O, 100);K = D(K, 100);function J(R, Q, P) {
      if (P < 0) {
        P += 1;
      }if (P > 1) {
        P -= 1;
      }if (P < 1 / 6) {
        return R + (Q - R) * 6 * P;
      }if (P < 1 / 2) {
        return Q;
      }if (P < 2 / 3) {
        return R + (Q - R) * (2 / 3 - P) * 6;
      }return R;
    }if (O === 0) {
      G = M = N = K;
    } else {
      var H = K < 0.5 ? K * (1 + O) : K + O - K * O;var I = 2 * K - H;G = J(I, H, L + 1 / 3);M = J(I, H, L);N = J(I, H, L - 1 / 3);
    }return { r: G * 255, g: M * 255, b: N * 255 };
  }function s(G, J, L) {
    G = D(G, 255);J = D(J, 255);L = D(L, 255);var M = k(G, J, L),
        H = h(G, J, L);var I,
        O,
        N = M;var K = M - H;O = M === 0 ? 0 : K / M;if (M == H) {
      I = 0;
    } else {
      switch (M) {case G:
          I = (J - L) / K + (J < L ? 6 : 0);break;case J:
          I = (L - G) / K + 2;break;case L:
          I = (G - J) / K + 4;break;}I /= 6;
    }return { h: I, s: O, v: N };
  }function w(K, R, P) {
    K = D(K, 360) * 6;R = D(R, 100);P = D(P, 100);var J = a.floor(K),
        M = K - J,
        I = P * (1 - R),
        H = P * (1 - M * R),
        Q = P * (1 - (1 - M) * R),
        O = J % 6,
        G = [P, H, I, I, Q, P][O],
        L = [Q, P, P, H, I, I][O],
        N = [I, I, Q, P, P, H][O];return { r: G * 255, g: L * 255, b: N * 255 };
  }function z(J, I, G, K) {
    var H = [f(A(J).toString(16)), f(A(I).toString(16)), f(A(G).toString(16))];if (K && H[0].charAt(0) == H[0].charAt(1) && H[1].charAt(0) == H[1].charAt(1) && H[2].charAt(0) == H[2].charAt(1)) {
      return H[0].charAt(0) + H[1].charAt(0) + H[2].charAt(0);
    }return H.join('');
  }function e(K, J, G, H) {
    var I = [f(C(H)), f(A(K).toString(16)), f(A(J).toString(16)), f(A(G).toString(16))];return I.join('');
  }y.equals = function (H, G) {
    if (!H || !G) {
      return false;
    }return y(H).toRgbString() == y(G).toRgbString();
  };y.random = function () {
    return y.fromRatio({ r: j(), g: j(), b: j() });
  };y.desaturate = function (H, I) {
    I = I === 0 ? 0 : I || 10;var G = y(H).toHsl();G.s -= I / 100;G.s = v(G.s);return y(G);
  };y.saturate = function (H, I) {
    I = I === 0 ? 0 : I || 10;var G = y(H).toHsl();G.s += I / 100;G.s = v(G.s);return y(G);
  };y.greyscale = function (G) {
    return y.desaturate(G, 100);
  };y.lighten = function (H, I) {
    I = I === 0 ? 0 : I || 10;var G = y(H).toHsl();G.l += I / 100;G.l = v(G.l);return y(G);
  };y.darken = function (H, I) {
    I = I === 0 ? 0 : I || 10;var G = y(H).toHsl();G.l -= I / 100;G.l = v(G.l);return y(G);
  };y.complement = function (H) {
    var G = y(H).toHsl();G.h = (G.h + 180) % 360;return y(G);
  };y.triad = function (H) {
    var G = y(H).toHsl();var I = G.h;return [y(H), y({ h: (I + 120) % 360, s: G.s, l: G.l }), y({ h: (I + 240) % 360, s: G.s, l: G.l })];
  };y.tetrad = function (H) {
    var G = y(H).toHsl();var I = G.h;return [y(H), y({ h: (I + 90) % 360, s: G.s, l: G.l }), y({ h: (I + 180) % 360, s: G.s, l: G.l }), y({ h: (I + 270) % 360, s: G.s, l: G.l })];
  };y.splitcomplement = function (H) {
    var G = y(H).toHsl();var I = G.h;return [y(H), y({ h: (I + 72) % 360, s: G.s, l: G.l }), y({ h: (I + 216) % 360, s: G.s, l: G.l })];
  };y.analogous = function (H, K, L) {
    K = K || 6;L = L || 30;var G = y(H).toHsl();var J = 360 / L;var I = [y(H)];for (G.h = (G.h - (J * K >> 1) + 720) % 360; --K;) {
      G.h = (G.h + J) % 360;I.push(y(G));
    }return I;
  };y.monochromatic = function (I, L) {
    L = L || 6;var K = y(I).toHsv();var N = K.h,
        M = K.s,
        H = K.v;var J = [];var G = 1 / L;while (L--) {
      J.push(y({ h: N, s: M, v: H }));H = (H + G) % 1;
    }return J;
  };y.readability = function (K, I) {
    var J = y(K).toRgb();var H = y(I).toRgb();var G = (J.r * 299 + J.g * 587 + J.b * 114) / 1000;var M = (H.r * 299 + H.g * 587 + H.b * 114) / 1000;var L = Math.max(J.r, H.r) - Math.min(J.r, H.r) + Math.max(J.g, H.g) - Math.min(J.g, H.g) + Math.max(J.b, H.b) - Math.min(J.b, H.b);return { brightness: Math.abs(G - M), color: L };
  };y.readable = function (H, G) {
    var I = y.readability(H, G);return I.brightness > 125 && I.color > 500;
  };y.mostReadable = function (N, M) {
    var J = null;var H = 0;var O = false;for (var L = 0; L < M.length; L++) {
      var I = y.readability(N, M[L]);var K = I.brightness > 125 && I.color > 500;var G = 3 * (I.brightness / 125) + I.color / 500;if (K && !O || K && O && G > H || !K && !O && G > H) {
        O = K;H = G;J = y(M[L]);
      }
    }return J;
  };var r = y.names = { aliceblue: 'f0f8ff', antiquewhite: 'faebd7', aqua: '0ff', aquamarine: '7fffd4', azure: 'f0ffff', beige: 'f5f5dc', bisque: 'ffe4c4', black: '000', blanchedalmond: 'ffebcd', blue: '00f', blueviolet: '8a2be2', brown: 'a52a2a', burlywood: 'deb887', burntsienna: 'ea7e5d', cadetblue: '5f9ea0', chartreuse: '7fff00', chocolate: 'd2691e', coral: 'ff7f50', cornflowerblue: '6495ed', cornsilk: 'fff8dc', crimson: 'dc143c', cyan: '0ff', darkblue: '00008b', darkcyan: '008b8b', darkgoldenrod: 'b8860b', darkgray: 'a9a9a9', darkgreen: '006400', darkgrey: 'a9a9a9', darkkhaki: 'bdb76b', darkmagenta: '8b008b', darkolivegreen: '556b2f', darkorange: 'ff8c00', darkorchid: '9932cc', darkred: '8b0000', darksalmon: 'e9967a', darkseagreen: '8fbc8f', darkslateblue: '483d8b', darkslategray: '2f4f4f', darkslategrey: '2f4f4f', darkturquoise: '00ced1', darkviolet: '9400d3', deeppink: 'ff1493', deepskyblue: '00bfff', dimgray: '696969', dimgrey: '696969', dodgerblue: '1e90ff', firebrick: 'b22222', floralwhite: 'fffaf0', forestgreen: '228b22', fuchsia: 'f0f', gainsboro: 'dcdcdc', ghostwhite: 'f8f8ff', gold: 'ffd700', goldenrod: 'daa520', gray: '808080', green: '008000', greenyellow: 'adff2f', grey: '808080', honeydew: 'f0fff0', hotpink: 'ff69b4', indianred: 'cd5c5c', indigo: '4b0082', ivory: 'fffff0', khaki: 'f0e68c', lavender: 'e6e6fa', lavenderblush: 'fff0f5', lawngreen: '7cfc00', lemonchiffon: 'fffacd', lightblue: 'add8e6', lightcoral: 'f08080', lightcyan: 'e0ffff', lightgoldenrodyellow: 'fafad2', lightgray: 'd3d3d3', lightgreen: '90ee90', lightgrey: 'd3d3d3', lightpink: 'ffb6c1', lightsalmon: 'ffa07a', lightseagreen: '20b2aa', lightskyblue: '87cefa', lightslategray: '789', lightslategrey: '789', lightsteelblue: 'b0c4de', lightyellow: 'ffffe0', lime: '0f0', limegreen: '32cd32', linen: 'faf0e6', magenta: 'f0f', maroon: '800000', mediumaquamarine: '66cdaa', mediumblue: '0000cd', mediumorchid: 'ba55d3', mediumpurple: '9370db', mediumseagreen: '3cb371', mediumslateblue: '7b68ee', mediumspringgreen: '00fa9a', mediumturquoise: '48d1cc', mediumvioletred: 'c71585', midnightblue: '191970', mintcream: 'f5fffa', mistyrose: 'ffe4e1', moccasin: 'ffe4b5', navajowhite: 'ffdead', navy: '000080', oldlace: 'fdf5e6', olive: '808000', olivedrab: '6b8e23', orange: 'ffa500', orangered: 'ff4500', orchid: 'da70d6', palegoldenrod: 'eee8aa', palegreen: '98fb98', paleturquoise: 'afeeee', palevioletred: 'db7093', papayawhip: 'ffefd5', peachpuff: 'ffdab9', peru: 'cd853f', pink: 'ffc0cb', plum: 'dda0dd', powderblue: 'b0e0e6', purple: '800080', red: 'f00', rosybrown: 'bc8f8f', royalblue: '4169e1', saddlebrown: '8b4513', salmon: 'fa8072', sandybrown: 'f4a460', seagreen: '2e8b57', seashell: 'fff5ee', sienna: 'a0522d', silver: 'c0c0c0', skyblue: '87ceeb', slateblue: '6a5acd', slategray: '708090', slategrey: '708090', snow: 'fffafa', springgreen: '00ff7f', steelblue: '4682b4', tan: 'd2b48c', teal: '008080', thistle: 'd8bfd8', tomato: 'ff6347', turquoise: '40e0d0', violet: 'ee82ee', wheat: 'f5deb3', white: 'fff', whitesmoke: 'f5f5f5', yellow: 'ff0', yellowgreen: '9acd32' };var F = y.hexNames = d(r);function d(I) {
    var H = {};for (var G in I) {
      if (I.hasOwnProperty(G)) {
        H[I[G]] = G;
      }
    }return H;
  }function q(G) {
    G = parseFloat(G);if (isNaN(G) || G < 0 || G > 1) {
      G = 1;
    }return G;
  }function D(I, G) {
    if (u(I)) {
      I = '100%';
    }var H = E(I);I = h(G, k(0, parseFloat(I)));if (H) {
      I = parseInt(I * G, 10) / 100;
    }if (a.abs(I - G) < 0.000001) {
      return 1;
    }return I % G / parseFloat(G);
  }function v(G) {
    return h(1, k(0, G));
  }function c(G) {
    return parseInt(G, 16);
  }function u(G) {
    return typeof G == 'string' && G.indexOf('.') != -1 && parseFloat(G) === 1;
  }function E(G) {
    return typeof G === 'string' && G.indexOf('%') != -1;
  }function f(G) {
    return G.length == 1 ? '0' + G : '' + G;
  }function g(G) {
    if (G <= 1) {
      G = G * 100 + '%';
    }return G;
  }function C(G) {
    return Math.round(parseFloat(G) * 255).toString(16);
  }function x(G) {
    return c(G) / 255;
  }var b = function () {
    var K = '[-\\+]?\\d+%?';var J = '[-\\+]?\\d*\\.\\d+%?';var G = '(?:' + J + ')|(?:' + K + ')';var I = '[\\s|\\(]+(' + G + ')[,|\\s]+(' + G + ')[,|\\s]+(' + G + ')\\s*\\)?';var H = '[\\s|\\(]+(' + G + ')[,|\\s]+(' + G + ')[,|\\s]+(' + G + ')[,|\\s]+(' + G + ')\\s*\\)?';return { rgb: new RegExp('rgb' + I), rgba: new RegExp('rgba' + H), hsl: new RegExp('hsl' + I), hsla: new RegExp('hsla' + H), hsv: new RegExp('hsv' + I), hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/, hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/ };
  }();function i(H) {
    H = H.replace(t, '').replace(n, '').toLowerCase();var G = false;if (r[H]) {
      H = r[H];G = true;
    } else {
      if (H == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: 'name' };
      }
    }var I;if (I = b.rgb.exec(H)) {
      return { r: I[1], g: I[2], b: I[3] };
    }if (I = b.rgba.exec(H)) {
      return { r: I[1], g: I[2], b: I[3], a: I[4] };
    }if (I = b.hsl.exec(H)) {
      return { h: I[1], s: I[2], l: I[3] };
    }if (I = b.hsla.exec(H)) {
      return { h: I[1], s: I[2], l: I[3], a: I[4] };
    }if (I = b.hsv.exec(H)) {
      return { h: I[1], s: I[2], v: I[3] };
    }if (I = b.hex8.exec(H)) {
      return { a: x(I[1]), r: c(I[2]), g: c(I[3]), b: c(I[4]), format: G ? 'name' : 'hex8' };
    }if (I = b.hex6.exec(H)) {
      return { r: c(I[1]), g: c(I[2]), b: c(I[3]), format: G ? 'name' : 'hex' };
    }if (I = b.hex3.exec(H)) {
      return { r: c(I[1] + '' + I[1]), g: c(I[2] + '' + I[2]), b: c(I[3] + '' + I[3]), format: G ? 'name' : 'hex' };
    }return false;
  }if (typeof module !== 'undefined' && module.exports) {
    module.exports = y;
  } else {
    if (true) {
      !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
        return y;
      }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
      window.tinycolor = y;
    }
  }
})();

/***/ }),
/* 2 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(5);

var _svg4everybody = __webpack_require__(6);

var _svg4everybody2 = _interopRequireDefault(_svg4everybody);

__webpack_require__(7);

__webpack_require__(8);

__webpack_require__(9);

var _callToListPhones = __webpack_require__(10);

var _callToListPhones2 = _interopRequireDefault(_callToListPhones);

var _resize_zabor = __webpack_require__(11);

var _resize_zabor2 = _interopRequireDefault(_resize_zabor);

__webpack_require__(12);

var _scroll = __webpack_require__(13);

var _scroll2 = _interopRequireDefault(_scroll);

__webpack_require__(1);

__webpack_require__(14);

__webpack_require__(15);

var _modalform_open = __webpack_require__(16);

var _modalform_open2 = _interopRequireDefault(_modalform_open);

var _modalform = __webpack_require__(17);

var _modalform2 = _interopRequireDefault(_modalform);

var _form_gazon = __webpack_require__(18);

var _form_gazon2 = _interopRequireDefault(_form_gazon);

var _zakaz_project = __webpack_require__(19);

var _zakaz_project2 = _interopRequireDefault(_zakaz_project);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(0, _svg4everybody2.default)();
var $ = __webpack_require__(0);


var init = function init() {
  _callToListPhones2.default.handler();
  _resize_zabor2.default.handler();
  $.fatNav();
  _scroll2.default.init();
  var startGalleryBut = $('.gallery__open-link');
  startGalleryBut.on('click', galleryStart);
  (0, _modalform_open2.default)();
  (0, _modalform2.default)();
  (0, _form_gazon2.default)();
  (0, _zakaz_project2.default)();
};

window.onload = init;

var galleryStart = function galleryStart(e) {
  var _$$jGallery;

  e.preventDefault();
  var openBlock = $('.gallery__open');
  var gallery = $('#gallery');
  $(openBlock).addClass('fadeout');
  $(gallery).jGallery((_$$jGallery = {
    mode: 'full-screen',
    canChangeMode: false,
    backgroundColor: '#edffc9',
    textColor: 'rgb(57, 57, 57)',
    canClose: true,
    thumbnails: true,
    hideThumbnailsOnInit: false,
    thumbnailsFullScreen: true,
    canZoom: true,
    preloadAll: false,
    slideshow: true,
    swipeEvents: true,
    thumbHeightOnFullScreen: 100,
    thumbnailsHideOnMobile: false,
    thumbType: 'image',
    thumbnailsPosition: 'bottom', // [ top | bottom | left | right 
    tooltipClose: 'Закрыть',
    tooltipSlideshow: 'Slideshow',
    autostartAtImage: 1,
    thumbWidthOnFullScreen: 100 }, _defineProperty(_$$jGallery, 'thumbHeightOnFullScreen', 100), _defineProperty(_$$jGallery, 'canMinimalizeThumbnails', true), _defineProperty(_$$jGallery, 'disabledOnIE8AndOlder', true), _defineProperty(_$$jGallery, 'transitionDuration', '0.7s'), _defineProperty(_$$jGallery, 'closeGallery', function closeGallery() {
    $(gallery).css('display', 'none');
    $(openBlock).removeClass('fadeout');
  }), _$$jGallery));
};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(root, factory) {
     true ? // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return root.svg4everybody = factory();
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == typeof module && module.exports ? // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory() : root.svg4everybody = factory();
}(this, function() {
    /*! svg4everybody v2.1.9 | github.com/jonathantneal/svg4everybody */
    function embed(parent, svg, target) {
        // if the target exists
        if (target) {
            // create a document fragment to hold the contents of the target
            var fragment = document.createDocumentFragment(), viewBox = !svg.hasAttribute("viewBox") && target.getAttribute("viewBox");
            // conditionally set the viewBox on the svg
            viewBox && svg.setAttribute("viewBox", viewBox);
            // copy the contents of the clone into the fragment
            for (// clone the target
            var clone = target.cloneNode(!0); clone.childNodes.length; ) {
                fragment.appendChild(clone.firstChild);
            }
            // append the fragment into the svg
            parent.appendChild(fragment);
        }
    }
    function loadreadystatechange(xhr) {
        // listen to changes in the request
        xhr.onreadystatechange = function() {
            // if the request is ready
            if (4 === xhr.readyState) {
                // get the cached html document
                var cachedDocument = xhr._cachedDocument;
                // ensure the cached html document based on the xhr response
                cachedDocument || (cachedDocument = xhr._cachedDocument = document.implementation.createHTMLDocument(""), 
                cachedDocument.body.innerHTML = xhr.responseText, xhr._cachedTarget = {}), // clear the xhr embeds list and embed each item
                xhr._embeds.splice(0).map(function(item) {
                    // get the cached target
                    var target = xhr._cachedTarget[item.id];
                    // ensure the cached target
                    target || (target = xhr._cachedTarget[item.id] = cachedDocument.getElementById(item.id)), 
                    // embed the target into the svg
                    embed(item.parent, item.svg, target);
                });
            }
        }, // test the ready state change immediately
        xhr.onreadystatechange();
    }
    function svg4everybody(rawopts) {
        function oninterval() {
            // while the index exists in the live <use> collection
            for (// get the cached <use> index
            var index = 0; index < uses.length; ) {
                // get the current <use>
                var use = uses[index], parent = use.parentNode, svg = getSVGAncestor(parent), src = use.getAttribute("xlink:href") || use.getAttribute("href");
                if (!src && opts.attributeName && (src = use.getAttribute(opts.attributeName)), 
                svg && src) {
                    if (polyfill) {
                        if (!opts.validate || opts.validate(src, svg, use)) {
                            // remove the <use> element
                            parent.removeChild(use);
                            // parse the src and get the url and id
                            var srcSplit = src.split("#"), url = srcSplit.shift(), id = srcSplit.join("#");
                            // if the link is external
                            if (url.length) {
                                // get the cached xhr request
                                var xhr = requests[url];
                                // ensure the xhr request exists
                                xhr || (xhr = requests[url] = new XMLHttpRequest(), xhr.open("GET", url), xhr.send(), 
                                xhr._embeds = []), // add the svg and id as an item to the xhr embeds list
                                xhr._embeds.push({
                                    parent: parent,
                                    svg: svg,
                                    id: id
                                }), // prepare the xhr ready state change event
                                loadreadystatechange(xhr);
                            } else {
                                // embed the local id into the svg
                                embed(parent, svg, document.getElementById(id));
                            }
                        } else {
                            // increase the index when the previous value was not "valid"
                            ++index, ++numberOfSvgUseElementsToBypass;
                        }
                    }
                } else {
                    // increase the index when the previous value was not "valid"
                    ++index;
                }
            }
            // continue the interval
            (!uses.length || uses.length - numberOfSvgUseElementsToBypass > 0) && requestAnimationFrame(oninterval, 67);
        }
        var polyfill, opts = Object(rawopts), newerIEUA = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/, webkitUA = /\bAppleWebKit\/(\d+)\b/, olderEdgeUA = /\bEdge\/12\.(\d+)\b/, edgeUA = /\bEdge\/.(\d+)\b/, inIframe = window.top !== window.self;
        polyfill = "polyfill" in opts ? opts.polyfill : newerIEUA.test(navigator.userAgent) || (navigator.userAgent.match(olderEdgeUA) || [])[1] < 10547 || (navigator.userAgent.match(webkitUA) || [])[1] < 537 || edgeUA.test(navigator.userAgent) && inIframe;
        // create xhr requests object
        var requests = {}, requestAnimationFrame = window.requestAnimationFrame || setTimeout, uses = document.getElementsByTagName("use"), numberOfSvgUseElementsToBypass = 0;
        // conditionally start the interval if the polyfill is active
        polyfill && oninterval();
    }
    function getSVGAncestor(node) {
        for (var svg = node; "svg" !== svg.nodeName.toLowerCase() && (svg = svg.parentNode); ) {}
        return svg;
    }
    return svg4everybody;
});

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

///*------------------------------------------------
///* звонок на случайный номер из списка телефонов 
///*------------------------------------------------

Object.defineProperty(exports, "__esModule", {
  value: true
});
var callToTelList = function () {
  // The Phone numbers
  var phoneNumbers = ['+88462312591', '+89093292911'],
      callButton = document.body.querySelector('#callPhone');
  /**
  * Returns a random integer between min (inclusive) and max (inclusive)
  * Using Math.round() will give you a non-uniform distribution!
  */
  var getRandomInt = function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  var call = function call(e) {
    e.preventDefault();
    // Get min and max index of the phone number array
    var min = 0,
        max = phoneNumbers.length - 1,

    // get the random phone number
    phoneNumberToCall = phoneNumbers[getRandomInt(min, max)];
    // Call the random number
    window.open('tel:' + phoneNumberToCall);
  };
  var handler = function handler() {
    callButton.addEventListener('click', call);
  };
  return { handler: handler };
}();

exports.default = callToTelList;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

///*------------------------------------------------
///* изменение положения забора в секции about
///* при ресайзе окна, чтобы скрыть прозрачный низ png
///* картинки и сохранить пропорции забора 
///*------------------------------------------------

Object.defineProperty(exports, "__esModule", {
  value: true
});
var resizeZabor = function () {
  var body = document.body,
      zaborDiv = body.querySelector('.zabor-bg');
  var moveZabor = function moveZabor() {
    //*** size footer_zabor.png: 1280px*114px
    //*** высота прозрачной области, которую нужно сдвинуть: 21px
    var wrapper = body.querySelector('.wrapper'),
        sizeOfWrapper = wrapper.getBoundingClientRect(),
        widthWrapper = sizeOfWrapper.width,
        zaborStyle = zaborDiv.style,
        zaborWidthInitial = 1280,
        moveY = widthWrapper * 21 / zaborWidthInitial;
    zaborStyle.transform = 'translateY(' + moveY + 'px)';
    zaborStyle.WebkitTransform = 'translateY(' + moveY + 'px)';
  };
  var handler = function handler() {
    moveZabor();
    window.addEventListener('resize', moveZabor);
  };
  return { handler: handler };
}();

exports.default = resizeZabor;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = __webpack_require__(0);
'use strict';
///*------------------------------------------
///* полноэкранное меню навигации по секциям    
///*------------------------------------------
var menuOverlay = function () {
  var pluginName = 'fatNav',
      defaults = {};
  function Plugin(options) {
    this.settings = $.extend({}, defaults, options);
    this._defaults = defaults;
    this._name = pluginName;
    this.init();
  }

  $.extend(Plugin.prototype, {

    init: function init() {

      var self = this;
      var $nav = this.$nav = $('.fat-nav');
      var $hamburger = $('.hamburg-menu');
      this._bodyOverflow = $('body').css('overflow');
      // Hack to prevent mobile safari scrolling the whole body when nav is open
      if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
        $nav.children().css({
          'height': '110%',
          'transform': 'translateY(-5%)'
        });
      }

      $().add($hamburger).add($nav.find('a')).on('click', function () {
        self.toggleNav();
      });
    },

    toggleNav: function toggleNav() {

      var self = this;

      this.$nav.fadeToggle(200);

      self.toggleBodyOverflow();

      $().add(this.$nav).toggleClass('active');
    },
    toggleBodyOverflow: function toggleBodyOverflow() {

      var self = this;

      var $body = $('body');

      $body.toggleClass('no-scroll');

      var isNavOpen = $body.hasClass('no-scroll');

      $body.width($body.width());
      $body.css('overflow', isNavOpen ? 'hidden' : self._bodyOverflow);
    }
  });

  if (typeof $[pluginName] === 'undefined') {

    $[pluginName] = function (options) {
      return new Plugin(this, options);
    };
  }
}($, window, document);
exports.default = menuOverlay;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

///*------------------------------------
///* скролл по секциям    
///*-------------------------------------

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var scrollSection = function () {
  var body = document.body,
      sections = [].concat(_toConsumableArray(body.querySelectorAll('.section[data-section]')));
  var arrOffset = [],
      links = [];

  function showSection(e) {
    e.preventDefault();
    arrOffset = sections.map(function (item) {
      return item.offsetTop;
    });
    var hash = e ? this.getAttribute('href') : window.location.hash,
        sectionAct = body.querySelector('.section[data-section="' + hash.replace(/#/, '') + '"'),
        index = sections.indexOf(sectionAct);
    var scrollPos = arrOffset[index];
    if (e) {
      animateMove(e, scrollPos);
    } else {
      document.documentElement.scrollTop = document.body.scrollTop = scrollPos;
    }
  }

  var animate = function animate(options) {

    var startPos = body.scrollTop || document.documentElement.scrollTop;
    var start = performance.now();
    requestAnimationFrame(function _animate(time) {
      // timeFraction от 0 до 1
      var timeFraction = (time - start) / options.duration;
      if (timeFraction > 1) {
        timeFraction = 1;
      }
      // текущее состояние анимации
      var progress = options.timing(timeFraction);
      options.move(progress, startPos);
      if (timeFraction < 1) {
        requestAnimationFrame(_animate);
      }
    });
  };

  var animateMove = function animateMove(e, scrollPos) {
    e.preventDefault();
    animate({
      duration: 800,
      timing: function timing(timeFraction) {
        return timeFraction;
      },
      move: function move(progress, startPos) {
        document.documentElement.scrollTop = document.body.scrollTop = startPos + (scrollPos - startPos) * progress;
      }
    });
  };

  var init = function init() {
    links = [].concat(_toConsumableArray(body.querySelectorAll('.hamburg-menu__link')));
    links.forEach(function (el) {
      el.addEventListener('click', showSection);
    });
    body.querySelector('#move2second').addEventListener('click', showSection);
  };
  return { init: init };
}();
exports.default = scrollSection;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
* jgallery 1.6.4
* http://jgallery.jakubkowalczyk.pl/
*
* Released under the MIT license
*
* Date: 2017-11-05
*/
var jQuery = __webpack_require__(0);
var tinycolor = __webpack_require__(1);
!function () {
  'use strict';
  var a = { autostart: !0, autostartAtImage: 1, autostartAtAlbum: 1, backgroundColor: '#fff', browserHistory: !0, canChangeMode: !0, canClose: !1, canMinimalizeThumbnails: !0, canZoom: !0, disabledOnIE8AndOlder: !0, draggableZoom: !0, draggableZoomHideNavigationOnMobile: !0, height: '600px', hideThumbnailsOnInit: !1, items: null, maxMobileWidth: 767, mode: 'standard', preloadAll: !1, slideshow: !0, slideshowAutostart: !1, slideshowCanRandom: !0, slideshowInterval: '8s', slideshowRandom: !1, swipeEvents: !0, textColor: '#000', thumbnails: !0, thumbHeight: 75, thumbHeightOnFullScreen: 100, thumbnailsFullScreen: !0, thumbnailsHideOnMobile: !0, thumbnailsPosition: 'bottom', thumbType: 'image', thumbWidth: 75, thumbWidthOnFullScreen: 100, title: !0, titleExpanded: !1, tooltipClose: 'Close', tooltipFullScreen: 'Full screen', tooltipRandom: 'Random', tooltips: !0, tooltipSeeAllPhotos: 'See all photos', tooltipSeeOtherAlbums: 'See other albums', tooltipSlideshow: 'Slideshow', tooltipToggleThumbnails: 'Toggle thumbnails', tooltipZoom: 'Zoom', transition: 'moveToLeft_moveFromRight', transitionBackward: 'auto', transitionCols: 1, transitionDuration: '0.7s', transitionRows: 1, transitionTimingFunction: 'cubic-bezier(0,1,1,1)', transitionWaveDirection: 'forward', width: '100%', zoomSize: 'fit', afterLoadPhoto: function afterLoadPhoto() {}, beforeLoadPhoto: function beforeLoadPhoto() {}, closeGallery: function closeGallery() {}, initGallery: function initGallery() {}, showGallery: function showGallery() {}, showPhoto: function showPhoto() {} },
      b = {},
      c = { width: '940px', height: '360px', canZoom: !1, draggableZoom: !1, browserHistory: !1, thumbnailsFullScreen: !1, thumbType: 'square', thumbWidth: 20, thumbHeight: 20, canMinimalizeThumbnails: !1, transition: 'rotateCubeRightOut_rotateCubeRightIn', transitionBackward: 'rotateCubeRightOut_rotateCubeRightIn', transitionCols: 6, transitionRows: 1, slideshow: !0, slideshowAutostart: !0, zoomSize: 'fill' },
      d = {},
      e = { autostart: !0, canClose: !1, zoomSize: 'fill', canChangeMode: !1 },
      f = { moveToLeft_moveFromRight: ['pt-page-moveToLeft', 'pt-page-moveFromRight'], moveToRight_moveFromLeft: ['pt-page-moveToRight', 'pt-page-moveFromLeft'], moveToTop_moveFromBottom: ['pt-page-moveToTop', 'pt-page-moveFromBottom'], moveToBottom_moveFromTop: ['pt-page-moveToBottom', 'pt-page-moveFromTop'], fade_moveFromRight: ['pt-page-fade', 'pt-page-moveFromRight pt-page-ontop'], fade_moveFromLeft: ['pt-page-fade', 'pt-page-moveFromLeft pt-page-ontop'], fade_moveFromBottom: ['pt-page-fade', 'pt-page-moveFromBottom pt-page-ontop'], fade_moveFromTop: ['pt-page-fade', 'pt-page-moveFromTop pt-page-ontop'], moveToLeftFade_moveFromRightFade: ['pt-page-moveToLeftFade', 'pt-page-moveFromRightFade'], moveToRightFade_moveFromLeftFade: ['pt-page-moveToRightFade', 'pt-page-moveFromLeftFade'], moveToTopFade_moveFromBottomFade: ['pt-page-moveToTopFade', 'pt-page-moveFromBottomFade'], moveToBottomFade_moveFromTopFade: ['pt-page-moveToBottomFade', 'pt-page-moveFromTopFade'], moveToLeftEasing_moveFromRight: ['pt-page-moveToLeftEasing pt-page-ontop', 'pt-page-moveFromRight'], moveToRightEasing_moveFromLeft: ['pt-page-moveToRightEasing pt-page-ontop', 'pt-page-moveFromLeft'], moveToTopEasing_moveFromBottom: ['pt-page-moveToTopEasing pt-page-ontop', 'pt-page-moveFromBottom'], moveToBottomEasing_moveFromTop: ['pt-page-moveToBottomEasing pt-page-ontop', 'pt-page-moveFromTop'], scaleDown_moveFromRight: ['pt-page-scaleDown', 'pt-page-moveFromRight pt-page-ontop'], scaleDown_moveFromLeft: ['pt-page-scaleDown', 'pt-page-moveFromLeft pt-page-ontop'], scaleDown_moveFromBottom: ['pt-page-scaleDown', 'pt-page-moveFromBottom pt-page-ontop'], scaleDown_moveFromTop: ['pt-page-scaleDown', 'pt-page-moveFromTop pt-page-ontop'], scaleDown_scaleUpDown: ['pt-page-scaleDown', 'pt-page-scaleUpDown pt-page-delay300'], scaleDownUp_scaleUp: ['pt-page-scaleDownUp', 'pt-page-scaleUp pt-page-delay300'], moveToLeft_scaleUp: ['pt-page-moveToLeft pt-page-ontop', 'pt-page-scaleUp'], moveToRight_scaleUp: ['pt-page-moveToRight pt-page-ontop', 'pt-page-scaleUp'], moveToTop_scaleUp: ['pt-page-moveToTop pt-page-ontop', 'pt-page-scaleUp'], moveToBottom_scaleUp: ['pt-page-moveToBottom pt-page-ontop', 'pt-page-scaleUp'], scaleDownCenter_scaleUpCenter: ['pt-page-scaleDownCenter', 'pt-page-scaleUpCenter pt-page-delay400'], rotateRightSideFirst_moveFromRight: ['pt-page-rotateRightSideFirst', 'pt-page-moveFromRight pt-page-delay200 pt-page-ontop'], rotateLeftSideFirst_moveFromLeft: ['pt-page-rotateLeftSideFirst', 'pt-page-moveFromLeft pt-page-delay200 pt-page-ontop'], rotateTopSideFirst_moveFromTop: ['pt-page-rotateTopSideFirst', 'pt-page-moveFromTop pt-page-delay200 pt-page-ontop'], rotateBottomSideFirst_moveFromBottom: ['pt-page-rotateBottomSideFirst', 'pt-page-moveFromBottom pt-page-delay200 pt-page-ontop'], flipOutRight_flipInLeft: ['pt-page-flipOutRight', 'pt-page-flipInLeft pt-page-delay500'], flipOutLeft_flipInRight: ['pt-page-flipOutLeft', 'pt-page-flipInRight pt-page-delay500'], flipOutTop_flipInBottom: ['pt-page-flipOutTop', 'pt-page-flipInBottom pt-page-delay500'], flipOutBottom_flipInTop: ['pt-page-flipOutBottom', 'pt-page-flipInTop pt-page-delay500'], rotateFall_scaleUp: ['pt-page-rotateFall pt-page-ontop', 'pt-page-scaleUp'], rotateOutNewspaper_rotateInNewspaper: ['pt-page-rotateOutNewspaper', 'pt-page-rotateInNewspaper pt-page-delay500'], rotatePushLeft_moveFromRight: ['pt-page-rotatePushLeft', 'pt-page-moveFromRight'], rotatePushRight_moveFromLeft: ['pt-page-rotatePushRight', 'pt-page-moveFromLeft'], rotatePushTop_moveFromBottom: ['pt-page-rotatePushTop', 'pt-page-moveFromBottom'], rotatePushBottom_moveFromTop: ['pt-page-rotatePushBottom', 'pt-page-moveFromTop'], rotatePushLeft_rotatePullRight: ['pt-page-rotatePushLeft', 'pt-page-rotatePullRight pt-page-delay180'], rotatePushRight_rotatePullLeft: ['pt-page-rotatePushRight', 'pt-page-rotatePullLeft pt-page-delay180'], rotatePushTop_rotatePullBottom: ['pt-page-rotatePushTop', 'pt-page-rotatePullBottom pt-page-delay180'], rotatePushBottom_page: ['pt-page-rotatePushBottom', 'pt-page-rotatePullTop pt-page-delay180'], rotateFoldLeft_moveFromRightFade: ['pt-page-rotateFoldLeft', 'pt-page-moveFromRightFade'], rotateFoldRight_moveFromLeftFade: ['pt-page-rotateFoldRight', 'pt-page-moveFromLeftFade'], rotateFoldTop_moveFromBottomFade: ['pt-page-rotateFoldTop', 'pt-page-moveFromBottomFade'], rotateFoldBottom_moveFromTopFade: ['pt-page-rotateFoldBottom', 'pt-page-moveFromTopFade'], moveToRightFade_rotateUnfoldLeft: ['pt-page-moveToRightFade', 'pt-page-rotateUnfoldLeft'], moveToLeftFade_rotateUnfoldRight: ['pt-page-moveToLeftFade', 'pt-page-rotateUnfoldRight'], moveToBottomFade_rotateUnfoldTop: ['pt-page-moveToBottomFade', 'pt-page-rotateUnfoldTop'], moveToTopFade_rotateUnfoldBottom: ['pt-page-moveToTopFade', 'pt-page-rotateUnfoldBottom'], rotateRoomLeftOut_rotateRoomLeftIn: ['pt-page-rotateRoomLeftOut pt-page-ontop', 'pt-page-rotateRoomLeftIn'], rotateRoomRightOut_rotateRoomRightIn: ['pt-page-rotateRoomRightOut pt-page-ontop', 'pt-page-rotateRoomRightIn'], rotateRoomTopOut_rotateRoomTopIn: ['pt-page-rotateRoomTopOut pt-page-ontop', 'pt-page-rotateRoomTopIn'], rotateRoomBottomOut_rotateRoomBottomIn: ['pt-page-rotateRoomBottomOut pt-page-ontop', 'pt-page-rotateRoomBottomIn'], rotateCubeLeftOut_rotateCubeLeftIn: ['pt-page-rotateCubeLeftOut pt-page-ontop', 'pt-page-rotateCubeLeftIn'], rotateCubeRightOut_rotateCubeRightIn: ['pt-page-rotateCubeRightOut pt-page-ontop', 'pt-page-rotateCubeRightIn'], rotateCubeTopOut_rotateCubeTopIn: ['pt-page-rotateCubeTopOut pt-page-ontop', 'pt-page-rotateCubeTopIn'], rotateCubeBottomOut_rotateCubeBottomIn: ['pt-page-rotateCubeBottomOut pt-page-ontop', 'pt-page-rotateCubeBottomIn'], rotateCarouselLeftOut_rotateCarouselLeftIn: ['pt-page-rotateCarouselLeftOut pt-page-ontop', 'pt-page-rotateCarouselLeftIn'], rotateCarouselRightOut_rotateCarouselRightIn: ['pt-page-rotateCarouselRightOut pt-page-ontop', 'pt-page-rotateCarouselRightIn'], rotateCarouselTopOut_rotateCarouselTopIn: ['pt-page-rotateCarouselTopOut pt-page-ontop', 'pt-page-rotateCarouselTopIn'], rotateCarouselBottomOut_rotateCarouselBottomIn: ['pt-page-rotateCarouselBottomOut pt-page-ontop', 'pt-page-rotateCarouselBottomIn'], rotateSidesOut_rotateSidesInDelay: ['pt-page-rotateSidesOut', 'pt-page-rotateSidesIn pt-page-delay200'], rotateSlideOut_rotateSlideIn: ['pt-page-rotateSlideOut', 'pt-page-rotateSlideIn'] },
      g = function (a) {
    var b = jQuery,
        c = [];return b.each(a, function (a, b) {
      c.push(b);
    }), c;
  }(f),
      h = { moveToLeft_moveFromRight: 'moveToRight_moveFromLeft', moveToRight_moveFromLeft: 'moveToLeft_moveFromRight', moveToTop_moveFromBottom: 'moveToBottom_moveFromTop', moveToBottom_moveFromTop: 'moveToTop_moveFromBottom', fade_moveFromRight: 'fade_moveFromLeft', fade_moveFromLeft: 'fade_moveFromRight', fade_moveFromBottom: 'fade_moveFromTop', fade_moveFromTop: 'fade_moveFromBottom', moveToLeftFade_moveFromRightFade: 'moveToRightFade_moveFromLeftFade', moveToRightFade_moveFromLeftFade: 'moveToLeftFade_moveFromRightFade', moveToTopFade_moveFromBottomFade: 'moveToBottomFade_moveFromTopFade', moveToBottomFade_moveFromTopFade: 'moveToTopFade_moveFromBottomFade', moveToLeftEasing_moveFromRight: 'moveToRightEasing_moveFromLeft', moveToRightEasing_moveFromLeft: 'moveToLeftEasing_moveFromRight', moveToTopEasing_moveFromBottom: 'moveToBottomEasing_moveFromTop', moveToBottomEasing_moveFromTop: 'moveToTopEasing_moveFromBottom', scaleDown_moveFromRight: 'scaleDown_moveFromLeft', scaleDown_moveFromLeft: 'scaleDown_moveFromRight', scaleDown_moveFromBottom: 'scaleDown_moveFromTop', scaleDown_moveFromTop: 'scaleDown_moveFromBottom', scaleDown_scaleUpDown: 'scaleDownUp_scaleUp', scaleDownUp_scaleUp: 'scaleDown_scaleUpDown', moveToLeft_scaleUp: 'moveToRight_scaleUp', moveToRight_scaleUp: 'moveToLeft_scaleUp', moveToTop_scaleUp: 'moveToBottom_scaleUp', moveToBottom_scaleUp: 'moveToTop_scaleUp', scaleDownCenter_scaleUpCenter: 'scaleDownCenter_scaleUpCenter', rotateRightSideFirst_moveFromRight: 'rotateLeftSideFirst_moveFromLeft', rotateLeftSideFirst_moveFromLeft: 'rotateRightSideFirst_moveFromRight', rotateTopSideFirst_moveFromTop: 'rotateBottomSideFirst_moveFromBottom', rotateBottomSideFirst_moveFromBottom: 'rotateTopSideFirst_moveFromTop', flipOutRight_flipInLeft: 'flipOutLeft_flipInRight', flipOutLeft_flipInRight: 'flipOutRight_flipInLeft', flipOutTop_flipInBottom: 'flipOutBottom_flipInTop', flipOutBottom_flipInTop: 'flipOutTop_flipInBottom', rotateFall_scaleUp: 'rotateFall_scaleUp', rotateOutNewspaper_rotateInNewspaper: 'rotateOutNewspaper_rotateInNewspaper', rotatePushLeft_moveFromRight: 'rotatePushRight_moveFromLeft', rotatePushRight_moveFromLeft: 'rotatePushLeft_moveFromRight', rotatePushTop_moveFromBottom: 'rotatePushBottom_moveFromTop', rotatePushBottom_moveFromTop: 'rotatePushTop_moveFromBottom', rotatePushLeft_rotatePullRight: 'rotatePushRight_rotatePullLeft', rotatePushRight_rotatePullLeft: 'rotatePushLeft_rotatePullRight', rotatePushTop_rotatePullBottom: 'rotatePushTop_rotatePullBottom', rotatePushBottom_page: 'rotatePushBottom_page', rotateFoldLeft_moveFromRightFade: 'rotateFoldRight_moveFromLeftFade', rotateFoldRight_moveFromLeftFade: 'rotateFoldLeft_moveFromRightFade', rotateFoldTop_moveFromBottomFade: 'rotateFoldBottom_moveFromTopFade', rotateFoldBottom_moveFromTopFade: 'rotateFoldTop_moveFromBottomFade', moveToRightFade_rotateUnfoldLeft: 'moveToLeftFade_rotateUnfoldRight', moveToLeftFade_rotateUnfoldRight: 'moveToRightFade_rotateUnfoldLeft', moveToBottomFade_rotateUnfoldTop: 'moveToTopFade_rotateUnfoldBottom', moveToTopFade_rotateUnfoldBottom: 'moveToBottomFade_rotateUnfoldTop', rotateRoomLeftOut_rotateRoomLeftIn: 'rotateRoomRightOut_rotateRoomRightIn', rotateRoomRightOut_rotateRoomRightIn: 'rotateRoomLeftOut_rotateRoomLeftIn', rotateRoomTopOut_rotateRoomTopIn: 'rotateRoomBottomOut_rotateRoomBottomIn', rotateRoomBottomOut_rotateRoomBottomIn: 'rotateRoomTopOut_rotateRoomTopIn', rotateCubeLeftOut_rotateCubeLeftIn: 'rotateCubeRightOut_rotateCubeRightIn', rotateCubeRightOut_rotateCubeRightIn: 'rotateCubeLeftOut_rotateCubeLeftIn', rotateCubeTopOut_rotateCubeTopIn: 'rotateCubeBottomOut_rotateCubeBottomIn', rotateCubeBottomOut_rotateCubeBottomIn: 'rotateCubeTopOut_rotateCubeTopIn', rotateCarouselLeftOut_rotateCarouselLeftIn: 'rotateCarouselRightOut_rotateCarouselRightIn', rotateCarouselRightOut_rotateCarouselRightIn: 'rotateCarouselLeftOut_rotateCarouselLeftIn', rotateCarouselTopOut_rotateCarouselTopIn: 'rotateCarouselBottomOut_rotateCarouselBottomIn', rotateCarouselBottomOut_rotateCarouselBottomIn: 'rotateCarouselTopOut_rotateCarouselTopIn', rotateSidesOut_rotateSidesInDelay: 'rotateSidesOut_rotateSidesInDelay', rotateSlideOut_rotateSlideIn: 'rotateSlideOut_rotateSlideIn' },
      i = function i() {
    return this.length ? this[0].outerHTML || function (a) {
      var b = document.createElement('div');b.appendChild(a.cloneNode(!0));var c = b.innerHTML;return b = null, c;
    }(this[0]) : this;
  },
      j = function () {
    var a = jQuery;return function (b) {
      var c = { show: !1, hide: !1, showLoader: !1, hideLoader: !1, showProgress: !1, hideProgress: !1, resetProgress: !1, fadeIn: !0, fadeOut: !0, fadeInLoader: !0, fadeOutLoader: !0, afterInit: function afterInit() {} };b = a.extend({}, c, b), this.each(function () {
        var c,
            d,
            e,
            f,
            g = a(this),
            h = g.is('.overlayContainer:has(.overlay)'),
            i = function i() {
          b.fadeIn ? c.fadeIn(500) : c.show();
        },
            j = function j() {
          b.fadeOut ? c.fadeOut(500) : c.hide();
        },
            k = function k() {
          b.fadeInLoader ? d.not(':visible').fadeIn(500) : d.not(':visible').show();
        },
            l = function l() {
          b.fadeOutLoader ? d.filter(':visible').fadeOut(500) : d.filter(':visible').hide();
        };h || (g.addClass('overlayContainer'), g.append('<span class="overlay" style="display: none;"><span class="imageLoaderPositionAbsolute" style="display: none;"><span class="fa fa-spin fa-spinner"></span><span class="progress-value" style="display: none;">0</span></span></span>'), b.afterInit()), c = g.children('.overlay'), d = g.find('.imageLoaderPositionAbsolute'), e = d.find('.progress-value'), f = d.find('.fa-spinner'), b.resetProgress && e.html('0'), b.showProgress ? (d.addClass('preloadAll'), e.show(), f.hide()) : b.hideProgress && (d.removeClass('preloadAll'), e.hide(), f.show()), c.stop(!1, !0), d.stop(!1, !0), b.show ? i() : b.hide && j(), b.showLoader ? k() : b.hideLoader && l();
      });
    };
  }(),
      k = function (a) {
    var b = jQuery;return b.fn.overlay = a, function (a) {
      a = b.extend({ interval: 1e3, skip: ':not(*)', start: function start() {
          b('body').overlay({ fadeIn: !1, fadeOut: !1, show: !0, showLoader: !0 }), b('body').show();
        }, success: function success() {
          b('body').overlay({ hide: !0 });
        }, progress: function progress() {} }, a), this.each(function () {
        function c() {
          var e,
              i = !0,
              j = 0;g.each(function () {
            b(this)[0].complete && b(this)[0].naturalWidth > 0 ? j++ : i = !1;
          }), e = parseInt(100 * j / h), a.progress({ percent: e }), i ? (clearTimeout(d), f.remove(), a.success()) : d = setTimeout(c, a.interval);
        }var d,
            e = b(this),
            f = b(),
            g = b(),
            h = 0;e.append('<div class="jLoaderTmp" style="position: absolute; width: 0; height: 0; line-height: 0; font-size: 0; visibility: hidden; overflow: hidden; z-index: -1;"></div>'), f = e.children('.jLoaderTmp:last-child'), b(e).add(e.find('*')).not(a.skip).each(function () {
          var a;'none' !== b(this).css('background-image') && (a = b(this).css('background-image'), /url/.exec(a) && (a = a.replace('"', '').replace('\'', '').replace(' ', '').replace('url(', '').replace(')', ''), f.append('<img src="' + a + '">')));
        }), g = e.find('img:not( ' + a.skip + ')'), e.is('img') && (e.is(a.skip) || (g = g.add(e))), h = parseInt(g.length), a.start(), c();
      });
    };
  }(j),
      l = function () {
    var a = jQuery,
        b = a('title');return function (c) {
      c = a.extend({}, { stateObj: {}, title: b.html(), path: '' }, c), window.history.pushState(c.stateObj, c.title, document.location.href.split('#')[0] + '#' + c.path);
    };
  }(),
      m = function m() {
    var a = !1;if ('Microsoft Internet Explorer' === navigator.appName) {
      var b = navigator.userAgent;null !== new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})').exec(b) && (a = !0);
    }return a;
  },
      n = function n() {
    var a = !1;if ('Microsoft Internet Explorer' === navigator.appName) {
      var b = navigator.userAgent;null !== new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})').exec(b) && (a = parseFloat(RegExp.$1), a = a < 9);
    }return a;
  },
      o = function o() {
    var a = jQuery,
        b = a('html');return function () {
      0 === b.find('.jgallery').length ? b.removeClass('has-jgallery') : b.addClass('has-jgallery'), 0 === b.find('.jgallery.hidden').length ? b.removeClass('has-hidden-jgallery') : b.addClass('has-hidden-jgallery'), 0 === b.find('.jgallery:not(.hidden)').length ? b.removeClass('has-visible-jgallery') : b.addClass('has-visible-jgallery');
    };
  },
      p = function (a) {
    var b = jQuery,
        c = b('head'),
        d = 0,
        e = function e(a) {
      a.is('[data-advanced-animation-id]') || (this.cols = 1, this.rows = 1, this.direction = 'forward', this.animation = !0, this.$element = a, this.$element.filter(':not( [data-advanced-animation-id] )').attr('data-advanced-animation-id', ++d), this.$element.find('.pt-item').wrap('<div class="pt-page" />'), this.$element.wrapInner('<div class="pt-part" />'), this.generateHtml(), this._showParts(this.$element.find('.pt-part'), 1));
    };return e.prototype = { next: function next() {
        var a = this.$element.find('.pt-part').eq('backward' === this.direction ? -1 : 0).find('.pt-page-current:not(.pt-page-prev)').next();a.length ? this.show(a) : this.show(this.$element.find('.pt-part').eq('backward' === this.direction ? -1 : 0).find('.pt-page').eq(0));
      }, show: function show(a, c) {
        var d = a.prevAll().length + 1;a.is('.pt-page-current:not(.pt-page-prev)') || (c = b.extend({}, { animation: !0 }, c), this.animation = c.animation, this._waveJumpToEnd(), this.animation ? this._runWave(d) : this._showParts(this.$element.find('.pt-part'), d), this.intPrevPtPageNumber = d);
      }, setQuantityParts: function setQuantityParts(a, b) {
        this.cols = a, this.rows = b, this.generateHtml();
      }, setAnimationProperties: function setAnimationProperties(b) {
        var d = this.$element.attr('data-advanced-animation-id'),
            e = c.find('style[data-advanced-animation-id="' + d + '"]');this.duration = b.duration, a() || (0 === e.length && (e = c.append('<style type="text/css" data-advanced-animation-id="' + d + '" />').children(':last-child')), e.html('                [data-advanced-animation-id="' + d + '"] .pt-page {                    -webkit-animation-duration: ' + b.duration + ';                    -moz-animation-duration: ' + b.duration + ';                    animation-duration: ' + b.duration + ';                    -webkit-animation-timing-function: ' + b.transitionTimingFunction + ';                    -moz-animation-timing-function: ' + b.transitionTimingFunction + ';                    animation-timing-function: ' + b.transitionTimingFunction + ';                }            '));
      }, setHideEffect: function setHideEffect(a) {
        this.prevHideEffect = this.hideEffect, this.hideEffect = a, /moveTo|rotateRoom|rotateCarousel|rotateSlideOut/.test(a) ? this.$element.find('.pt-part').addClass('hide-overflow') : this.$element.find('.pt-part').removeClass('hide-overflow');
      }, setShowEffect: function setShowEffect(a) {
        this.prevShowEffect = this.showEffect, this.showEffect = a;
      }, setDirection: function setDirection(a) {
        this.direction = a;
      }, _runWave: function _runWave(a) {
        this.$element.find('.pt-part').addClass('in-queue'), this._showNextPart(a);
      }, _waveJumpToEnd: function _waveJumpToEnd() {
        clearTimeout(this.showPartsTimeout), void 0 !== this.intPrevPtPageNumber && this._showParts(this.$element.find('.pt-part.in-queue').removeClass('in-queue'), this.intPrevPtPageNumber);
      }, _showNextPart: function _showNextPart(a) {
        var b = this,
            c = this.$element.find('.pt-part.in-queue').eq('backward' === this.direction ? -1 : 0);0 !== c.length && (this._showParts(c.removeClass('in-queue'), a), 0 !== c.length && (clearTimeout(this.showPartsTimeout), this.showPartsTimeout = setTimeout(function () {
          b._showNextPart(a);
        }, 1e3 * parseFloat(this.duration) * .25 / Math.max(1, this.$element.find('.pt-part').length - 1))));
      }, _showParts: function _showParts(a, b) {
        a.find('.pt-page-current.pt-page-prev').removeClass('pt-page-prev').removeClass('pt-page-current'), a.find('.pt-page-current').addClass('pt-page-prev'), a.find('.pt-page:nth-child(' + b + ')').addClass('pt-page-current'), a.find('.pt-page').removeClass(this.hideEffect).removeClass(this.showEffect), void 0 !== this.prevHideEffect && a.find('.pt-page').removeClass(this.prevHideEffect), void 0 !== this.prevShowEffect && a.find('.pt-page').removeClass(this.prevShowEffect), this.animation && (a.find('.pt-page-prev').addClass(this.hideEffect), a.find('.pt-page-current:not(.pt-page-prev)').addClass(this.showEffect));
      }, hideActive: function hideActive() {
        this.$element.find('.pt-page-current').addClass('pt-page-prev').addClass(this.hideEffect);
      }, generateHtml: function generateHtml() {
        var a, b, c;for (this.$element.html(this.$element.find('.pt-part').eq(0).html()), c = this.$element.html(), this.$element.children('.pt-part').remove(), b = 0; b < this.rows; b++) {
          for (a = 0; a < this.cols; a++) {
            this.$element.append('<div class="pt-part pt-perspective" data-col-no="' + a + '" data-row-no="' + b + '" style="position: absolute;"></div>').children(':last-child').html(c).find('.pt-item');
          }
        }this.setPositionParts(), this.$element.children(':not(.pt-part)').remove();
      }, setPositionParts: function setPositionParts() {
        var a = this,
            c = this.$element.outerWidth(),
            d = this.$element.outerHeight(),
            e = c / this.cols,
            f = d / this.rows;this.$element.find('.pt-part').each(function () {
          var g = b(this),
              h = g.attr('data-col-no'),
              i = g.attr('data-row-no');g.css({ left: a.$element.outerWidth() * (100 / a.cols * h) / 100 + 'px', top: a.$element.outerHeight() * (100 / a.rows * i) / 100 + 'px', width: a.$element.outerWidth() * (100 / a.cols) / 100 + 1 + 'px', height: a.$element.outerHeight() * (100 / a.rows) / 100 + 1 + 'px' }).find('.pt-item').css({ width: c, height: d, left: -e * h, top: -f * i });
        });
      } }, e;
  }(n),
      q = function () {
    var a = jQuery,
        b = a('html'),
        c = function c(a, b) {
      this.$element = a, this.jGallery = b, this.$title = this.$element.find('.title');
    };return c.prototype = { bindEvents: function bindEvents(c) {
        var d = this;this.getElement().on({ click: function click(a) {
            d.menuToggle(), a.stopPropagation();
          } }), this.getItemsOfMenu().on({ click: function click() {
            var b = a(this);b.is('.active') || c.thumbnails.setActiveAlbum(c.thumbnails.$albums.filter('[data-jgallery-album-title="' + b.attr('data-jgallery-album-title') + '"]'));
          } }), b.on('click', function () {
          d.menuHide();
        });
      }, setTitle: function setTitle(a) {
        this.$title.html(a);
      }, getTitle: function getTitle() {
        return this.$title.html();
      }, getListOfAlbums: function getListOfAlbums() {
        return this.getElement().find('.menu');
      }, getElement: function getElement() {
        return this.$element;
      }, getItemsOfMenu: function getItemsOfMenu() {
        return this.getListOfAlbums().find('.item');
      }, appendToMenu: function appendToMenu(a) {
        this.getListOfAlbums().append(a);
      }, menuToggle: function menuToggle() {
        this.getElement().toggleClass('active');
      }, menuHide: function menuHide() {
        this.getElement().removeClass('active');
      }, clearMenu: function clearMenu() {
        this.getListOfAlbums().html('');
      }, refreshMenuHeight: function refreshMenuHeight() {
        this.getListOfAlbums().css('max-height', this.jGallery.zoom.$container.outerHeight() - 8);
      } }, c;
  }(),
      r = function () {
    var a = function a(_a, b) {
      this.jGallery = b, this.$element = _a;
    };return a.prototype = { clear: function clear() {
        return this.$element.stop(!1, !0).css({ width: 0 }), this;
      }, start: function start(a, b) {
        var c = 1e3 * parseInt(this.jGallery.options.slideshowInterval),
            d = this.$element;return d.animate({ width: a }, c - c * (d.width() / d.parent().width()), 'linear', b), this;
      }, pause: function pause() {
        return this.$element.stop(), this;
      } }, a;
  }(),
      s = function () {
    var a = jQuery,
        b = function b(_b) {
      a.extend(this, { photoId: 0, number: 0, url: '', link: '', target: '', thumbUrl: '', title: '', bgColor: '', textColor: '' }, _b);
    };return b.prototype = { generateImgTag: function generateImgTag(b) {
        var c = a('<img src="' + b.src + '" />');return b.alt && c.attr('alt', b.alt), b.bgColor && c.attr('data-jgallery-bg-color', b.bgColor), b.textColor && c.attr('data-jgallery-text-color', b.textColor), c;
      }, preload: function preload() {
        var a = this.$element;a.jLoader({ start: function start() {
            a.overlay({ fadeIn: !1, fadeOut: !1, show: !0, showLoader: !0 });
          }, success: function success() {
            a.overlay({ hide: !0 });
          } });
      }, render: function render() {
        var b = this.$element = a('<a href="' + this.url + '">' + this.generateImgTag({ src: this.thumbUrl, bgColor: this.bgColor, textColor: this.textColor, alt: this.title }).outerHtml() + '</a>');return this.target && b.attr('target', this.target), this.link && b.attr('link', this.link), b.attr('data-jgallery-photo-id', this.photoId).attr('data-jgallery-number', this.number), b;
      } }, b;
  }(),
      t = function (a) {
    var b = jQuery,
        c = b('head'),
        d = b(window);b.fn.jLoader = a;var e = function e(a) {
      this.$element = a.$element.find('.jgallery-thumbnails'), this.$a = this.getElement().find('a'), this.$img = this.getElement().find('img'), this.$container = this.getElement().find('.jgallery-container'), this.$albums = this.getElement().find('.album').length ? this.getElement().find('.album') : this.getElement().find('.jgallery-container-inner').addClass('active'), this.$btnNext = this.getElement().children('.next'), this.$btnPrev = this.getElement().children('.prev'), this.intJgalleryId = a.$element.attr('data-jgallery-id'), this.isJgalleryInitialized = a.$element.is('[data-jgallery-id]'), this.zoom = a.zoom, this.$iconToggleThumbsVisibility = this.zoom.$container.find('.minimalize-thumbnails'), this.jGallery = a, this.jGallery.options.swipeEvents && this.initSwipeEvents();
    };return e.prototype = { getElement: function getElement() {
        return this.$element;
      }, init: function init() {
        this.getElement().removeClass('square number images jgallery-thumbnails-left jgallery-thumbnails-right jgallery-thumbnails-top jgallery-thumbnails-bottom jgallery-thumbnails-horizontal jgallery-thumbnails-vertical'), this.getElement().addClass('jgallery-thumbnails-' + this.jGallery.options.thumbnailsPosition), this.isVertical() && this.getElement().addClass('jgallery-thumbnails-vertical'), this.isHorizontal() && this.getElement().addClass('jgallery-thumbnails-horizontal'), 'image' === this.jGallery.options.thumbType && this._initImages(), 'square' === this.jGallery.options.thumbType && this._initSquare(), 'number' === this.jGallery.options.thumbType && this._initNumber();
      }, initSwipeEvents: function initSwipeEvents() {
        if (b.fn.swipe) {
          var a,
              c,
              d = this.$container,
              e = this,
              f = function f(a) {
            e.isVertical() || e.isFullScreen() ? d.css({ '-webkit-transform': 'translateY(' + a + 'px)', transform: 'translateY(' + a + 'px)' }) : d.css({ '-webkit-transform': 'translateX(' + a + 'px)', transform: 'translateX(' + a + 'px)' });
          };d.swipe({ swipeStatus: function swipeStatus(b, d, g, h) {
              'start' === d ? (a = e.canScrollToPrev(), c = e.canScrollToNext()) : 'move' === d ? !c || 'left' !== g && 'down' !== g ? a && f(h) : f(-h) : 'end' === d ? !c || 'left' !== g && 'down' !== g ? a && (e._scrollToPrev(), f(0)) : (e._scrollToNext(), f(0)) : f(0);
            } });
        }
      }, show: function show() {
        var a = this;this.getElement().is('.hidden') && (this.jGallery.isMobile() && this.jGallery.options.thumbnailsHideOnMobile || this.getElement().removeClass('hidden'), this.getElement().is('.loaded') ? (this._showNextThumb(), this.$a.parent('.album:not(.active)').children('.hidden').removeClass('hidden')) : this.getElement().jLoader({ start: function start() {}, success: function success() {
            a._showNextThumb(), a.$a.parent('.album:not(.active)').children('.hidden').removeClass('hidden'), a.getElement().addClass('loaded');
          } }), this.$iconToggleThumbsVisibility.removeClass('inactive'));
      }, showThumbsForActiveAlbum: function showThumbsForActiveAlbum() {
        this.$a.addClass('hidden'), this._showNextThumb();
      }, hide: function hide(a) {
        a = b.extend({ hideEachThumb: !0 }, a), this.getElement().addClass('hidden'), a.hideEachThumb && this.$a.addClass('hidden'), this.$iconToggleThumbsVisibility.addClass('inactive');
      }, toggle: function toggle() {
        this.getElement().is('.hidden') ? this.show() : this.hide({ hideEachThumb: !1 });
      }, setActiveThumb: function setActiveThumb(a) {
        var b = a.find('img'),
            c = this.$albums.filter('.active'),
            a = c.find('img[src="' + b.attr('src') + '"]').parent('a').eq(0);this.getElement().find('a').removeClass('active'), a.addClass('active'), 0 === c.find('a.active').length && c.find('a:first-child').eq(0).addClass('active'), this.center(a);
      }, isHorizontal: function isHorizontal() {
        return 'top' === this.jGallery.options.thumbnailsPosition || 'bottom' === this.jGallery.options.thumbnailsPosition;
      }, isVertical: function isVertical() {
        return 'left' === this.jGallery.options.thumbnailsPosition || 'right' === this.jGallery.options.thumbnailsPosition;
      }, isFullScreen: function isFullScreen() {
        return this.getElement().is('.full-screen');
      }, refreshNavigation: function refreshNavigation() {
        this.canScrollToPrev() ? this.$btnPrev.addClass('visible') : this.$btnPrev.removeClass('visible'), this.canScrollToNext() ? this.$btnNext.addClass('visible') : this.$btnNext.removeClass('visible');
      }, center: function center(a) {
        this.isHorizontal() && this._horizontalCenter(a), this.isVertical() && this._verticalCenter(a);
      }, reload: function reload() {
        this.$a = this.getElement().find('a'), this.$img = this.getElement().find('img'), this.$albums = this.getElement().find('.album').length ? this.getElement().find('.album') : this.getElement().find('.jgallery-container-inner'), this.zoom.showPhoto(this.$albums.find('a').eq(0));
      }, bindEvents: function bindEvents() {
        var a = this;this.$btnNext.on('click', function () {
          a._scrollToNext();
        }), this.$btnPrev.on('click', function () {
          a._scrollToPrev();
        }), this.zoom.$container.find('.full-screen').on({ click: function click() {
            a.zoom.slideshowPause(), a.changeViewToFullScreen();
          } }), this.getElement().find('.jgallery-close').on({ click: function click() {
            a.changeViewToBar(), a.zoom.refreshSize();
          } });
      }, changeViewToBar: function changeViewToBar() {
        this.getElement().removeClass('full-screen'), this.isHorizontal() && this.getElement().addClass('jgallery-thumbnails-horizontal').removeClass('jgallery-thumbnails-vertical'), this.refreshNavigation();
      }, changeViewToFullScreen: function changeViewToFullScreen() {
        this.getElement().addClass('full-screen'), this.isHorizontal() && this.getElement().addClass('jgallery-thumbnails-vertical').removeClass('jgallery-thumbnails-horizontal'), this.refreshNavigation();
      }, setActiveAlbum: function setActiveAlbum(a) {
        this.jGallery.booIsAlbums && !a.is('.active') && (this.$albums.not(a.get(0)).removeClass('active'), a.addClass('active'), this.jGallery.iconChangeAlbum.getListOfAlbums().find('.item').removeClass('active').filter('[data-jgallery-album-title="' + a.attr('data-jgallery-album-title') + '"]').addClass('active'), this.jGallery.iconChangeAlbum.setTitle(a.attr('data-jgallery-album-title')), this.refreshNavigation(), !this.getElement().is('.full-screen') && this.jGallery.$element.is(':visible') && this.zoom.showPhoto(a.find('a').eq(0)), this.showThumbsForActiveAlbum(), this.zoom.slideshowStop());
      }, _initSquare: function _initSquare() {
        this.getElement().addClass('square');
      }, _initNumber: function _initNumber() {
        this.getElement().addClass('number'), this._initSquare();
      }, _initImages: function _initImages() {
        var a = c.find('style.jgallery-thumbnails[data-jgallery-id="' + this.intJgalleryId + '"]'),
            b = '                    .jgallery[data-jgallery-id="' + this.intJgalleryId + '"] .jgallery-thumbnails a {\n                        width: ' + this.jGallery.options.thumbWidth + 'px;\n                        height: ' + this.jGallery.options.thumbHeight + 'px;\n                        font-size: ' + this.jGallery.options.thumbHeight + 'px;\n                    }\n                    .jgallery[data-jgallery-id="' + this.intJgalleryId + '"] .jgallery-thumbnails.full-screen a {\n                        width: ' + this.jGallery.options.thumbWidthOnFullScreen + 'px;\n                        height: ' + this.jGallery.options.thumbHeightOnFullScreen + 'px;\n                        font-size: ' + this.jGallery.options.thumbHeightOnFullScreen + 'px;\n                    }\n                    .jgallery[data-jgallery-id="' + this.intJgalleryId + '"] .jgallery-thumbnails-horizontal {\n                        height: ' + parseInt(this.jGallery.options.thumbHeight + 2) + 'px;\n                    }\n                    .jgallery[data-jgallery-id="' + this.intJgalleryId + '"] .jgallery-thumbnails-vertical {\n                        width: ' + parseInt(this.jGallery.options.thumbWidth + 2) + 'px;\n                    }\n            ';this.getElement().addClass('images'), a.length ? a.html(b) : c.append('                <style type="text/css" class="jgallery-thumbnails" data-jgallery-id="' + this.intJgalleryId + '">                    ' + b + '                </style>            '), this.isHorizontal() ? this.jGallery.zoom.$container.find('.minimalize-thumbnails').addClass('fa-ellipsis-h').removeClass('fa-ellipsis-v') : this.jGallery.zoom.$container.find('.minimalize-thumbnails').addClass('fa-ellipsis-v').removeClass('fa-ellipsis-h'), this.isJgalleryInitialized || this.hide();
      }, _showNextThumb: function _showNextThumb() {
        var a = this,
            b = this.$a.parent('.active').children('.hidden').eq(0);setTimeout(function () {
          b.removeClass('hidden'), b.length && a._showNextThumb();
        }, 70);
      }, _horizontalCenter: function _horizontalCenter(a) {
        var b = this;1 === a.length && this.$container.stop(!1, !0).animate({ scrollLeft: a.position().left - -1 * this.$container.scrollLeft() - a.outerWidth() / -2 - this.$container.outerWidth() / 2 }, function () {
          b.refreshNavigation();
        });
      }, _verticalCenter: function _verticalCenter(a) {
        var b = this;1 === a.length && this.$container.stop(!1, !0).animate({ scrollTop: a.position().top - -1 * this.$container.scrollTop() - a.outerHeight() / -2 - this.$container.outerHeight() / 2 }, function () {
          b.refreshNavigation();
        });
      }, canScrollToPrev: function canScrollToPrev() {
        return this.isVertical() || this.isFullScreen() ? this.$container.scrollTop() > 0 : this.$container.scrollLeft() > 0;
      }, canScrollToNext: function canScrollToNext() {
        if (this.isVertical() || this.isFullScreen()) return this.$container.find('.jgallery-container-inner').height() > this.$container.height() + this.$container.scrollTop();var a = this.getElement().find('div.active');return ('image' === this.jGallery.options.thumbType ? this.$a.outerWidth(!0) * a.find('img').length : this.$a.outerWidth(!0) * a.find('a').length) > this.$container.width() + this.$container.scrollLeft();
      }, _scrollToPrev: function _scrollToPrev() {
        var a = this;this.isVertical() || this.isFullScreen() ? this.$container.stop(!1, !0).animate({ scrollTop: '-=' + .7 * d.height() }, function () {
          a.refreshNavigation();
        }) : this.isHorizontal() && this.$container.stop(!1, !0).animate({ scrollLeft: '-=' + .7 * d.width() }, function () {
          a.refreshNavigation();
        });
      }, _scrollToNext: function _scrollToNext() {
        var a = this;this.isVertical() || this.isFullScreen() ? this.$container.stop(!1, !0).animate({ scrollTop: '+=' + .7 * d.height() }, function () {
          a.refreshNavigation();
        }) : this.isHorizontal() && this.$container.stop(!1, !0).animate({ scrollLeft: '+=' + .7 * d.width() }, function () {
          a.refreshNavigation();
        });
      } }, e;
  }(k),
      u = function (a, b) {
    var c = jQuery;c.fn.outerHtml = a, c.fn.jLoader = b;var d = function d(a, b) {
      this.options = c.extend({}, { thumbsHidden: !0 }, b), this.jGallery = a, this.isSlider = a.isSlider(), this.$element = a.$this, this.booIsAlbums = a.booIsAlbums, this.$tmp, this.intI = 1, this.intJ = 1, this.intNo, this.$thumbnailsContainerInner = this.jGallery.$jgallery.find('.jgallery-thumbnails .jgallery-container-inner'), this.start();
    };return d.prototype = { start: function start() {
        this.$thumbnailsContainerInner.html(''), this.jGallery.options.items ? this.processOptions() : this.processHtml(), this.refreshThumbsSize();
      }, processOptions: function processOptions() {
        function a(a, b) {
          var d = new s(c.extend({ photoId: this.intI++, number: this.intNo++ }, a));b.append(d.render()), d.preload();
        }this.booIsAlbums ? this.jGallery.options.items.forEach(function (b) {
          var c = this.$thumbnailsContainerInner.append('<div class="album" data-jgallery-album-title="' + b.title + '"></div>').children(':last-child');this.intNo = 1, b.images.forEach(function (b) {
            a.call(this, b, c);
          }, this);
        }, this) : (this.intNo = 1, this.jGallery.options.items.forEach(function (b) {
          a.call(this, b, this.$thumbnailsContainerInner);
        }, this));
      }, processHtml: function processHtml() {
        var a = this,
            b = this.jGallery.isSlider() ? '.album:has(img)' : '.album:has(a:has(img))';c('body').append('<div id="jGalleryTmp" style="position: absolute; top: 0; left: 0; width: 0; height: 0; z-index: -1; overflow: hidden;">' + this.$element.html() + '</div>'), this.$tmp = c('#jGalleryTmp'), this.booIsAlbums ? this.$tmp.find(b).each(function () {
          a.insertAlbum(c(this));
        }) : this.insertImages(this.$tmp, this.$thumbnailsContainerInner), this.$tmp.remove();
      }, insertAlbum: function insertAlbum(a) {
        var b = a.is('[data-jgallery-album-title]') ? a.attr('data-jgallery-album-title') : 'Album ' + this.intJ,
            c = this.$thumbnailsContainerInner.append('<div class="album" data-jgallery-album-title="' + b + '"></div>').children(':last-child');1 === this.intJ && c.addClass('active'), this.insertImages(a, c), this.intJ++;
      }, insertImages: function insertImages(a, b) {
        var d = this,
            e = this.jGallery.isSlider() ? 'img' : 'a:has(img)';this.intNo = 1, a.find(e).each(function () {
          d.insertImage(c(this), b);
        });
      }, insertImage: function insertImage(a, b) {
        var c = a.parent(),
            d = a.is('img') ? a : a.find('img').eq(0),
            e = new s({ photoId: this.intI++, number: this.intNo++, url: a.is('img') && this.isSlider ? a.attr('src') : a.attr('href'), link: a.is('img') && this.isSlider && c.is('a') ? c.attr('href') : void 0, target: a.is('img') && this.isSlider && c.is('a') && c.is('[target]') ? c.attr('target') : void 0, thumbUrl: d.attr('src'), title: d.attr('alt'), bgColor: d.attr('data-jgallery-bg-color'), textColor: d.attr('data-jgallery-text-color') });b.append(e.render()), e.preload();
      }, refreshThumbsSize: function refreshThumbsSize() {
        var a = this.jGallery.options;this.$thumbnailsContainerInner.find('img').each(function () {
          var b = c(this),
              d = new Image();d.src = b.attr('src'), d.width / d.height < a.thumbWidth / a.thumbHeight ? b.addClass('thumb-vertical').removeClass('thumb-horizontal') : b.addClass('thumb-horizontal').removeClass('thumb-vertical'), d.width / d.height < a.thumbWidthOnFullScreen / a.thumbHeightOnFullScreen ? b.addClass('thumb-on-full-screen-vertical').removeClass('thumb-on-full-screen-horizontal') : b.addClass('thumb-on-full-screen-horizontal').removeClass('thumb-on-full-screen-vertical');
        });
      } }, d;
  }(i, k),
      v = function (a, b, c, d, e, f, g, h) {
    var i = jQuery,
        j = i('body');i.fn.jLoader = a, i.fn.overlay = b;var k = function k(a) {
      this.$container = a.$element.children('.zoom-container'), this.$element = this.$container.children('.zoom'), this.$title = this.$container.find('.nav-bottom > .title'), this.$btnPrev = this.$container.children('.prev'), this.$btnNext = this.$container.children('.next'), this.thumbnails = a.thumbnails, this.$jGallery = a.$element, this.jGallery = a, this.$resize = this.$container.find('.resize'), this.$dragNav = this.$container.find('.drag-nav'), this.$dragNavCrop = i(), this.$dragNavCropImg = i(), this.$changeMode = this.$container.find('.fa.change-mode'), this.$random = this.$container.find('.random'), this.$slideshow = this.$container.find('.slideshow'), this.intJGalleryId = this.$jGallery.attr('data-jgallery-id'), this.booSlideshowPlayed = !1, this.booLoadingInProgress = !1, this.booLoadedAll = !1, this.$title.on('click', function () {
        i(this).toggleClass('expanded');
      }), this.update(), this.enableDrag();
    };return k.prototype = { update: function update() {
        var a = d[this.jGallery.options.transition];this.$container.attr('data-size', this.jGallery.options.zoomSize), this.$element.find('.pt-page').removeClass(this.jGallery.options.hideEffect).removeClass(this.jGallery.options.showEffect), void 0 !== a && (this.jGallery.options.hideEffect = a[0], this.jGallery.options.showEffect = a[1]), this.initAdvancedAnimation();
      }, initAdvancedAnimation: function initAdvancedAnimation() {
        void 0 === this.advancedAnimation && (this.advancedAnimation = new g(this.$element)), this.advancedAnimation.setAnimationProperties({ duration: this.jGallery.options.transitionDuration, transitionTimingFunction: this.jGallery.options.transitionTimingFunction }), this.advancedAnimation.setDirection(this.jGallery.options.transitionWaveDirection), this.advancedAnimation.setQuantityParts(this.jGallery.options.transitionCols, this.jGallery.options.transitionRows), this.advancedAnimation.setHideEffect(this.jGallery.options.hideEffect), this.advancedAnimation.setShowEffect(this.jGallery.options.showEffect);
      }, setThumbnails: function setThumbnails(a) {
        this.thumbnails = a;
      }, showDragNav: function showDragNav() {
        this.$dragNav.removeClass('hide').addClass('show');
      }, hideDragNav: function hideDragNav() {
        this.$dragNav.removeClass('show').addClass('hide');
      }, refreshDragNavVisibility: function refreshDragNavVisibility() {
        var a = this.$element.find('img.active');a.width() <= this.$element.outerWidth() || a.height() <= this.$element.outerHeight() ? this.hideDragNav() : this.showDragNav();
      }, enableDrag: function enableDrag() {
        var a,
            b,
            c,
            d,
            e,
            f,
            g = this,
            h = function h() {
          return parseInt(a) - parseInt(f.css('margin-left'));
        },
            i = function i(h) {
          c = h.pageX, d = h.pageY, e = h, f = g.$element.find('img.active'), a = f.css('margin-left'), b = f.css('margin-top'), g.$element.on({ mousemove: k, touchmove: k, mouseleave: j, touchend: j }), 'fill' === g.jGallery.options.zoomSize && g.$dragNav.removeClass('hide').addClass('show'), l(0, 0);
        },
            j = function j() {
          var a = h(),
              b = c - e.pageX;g.$element.off('mousemove touchmove mouseleave touchend'), 'fill' === g.jGallery.options.zoomSize && g.$dragNav.removeClass('show').addClass('hide'), g.jGallery.options.swipeEvents && 0 === a && (b > 0 ? g.showNextPhoto() : b < 0 && g.showPrevPhoto());
        },
            k = function k(a) {
          e = 'touchmove' === a.type ? a.originalEvent.touches[0] : a;var b = { x: e.pageX - c, y: e.pageY - d },
              f = {};g.jGallery.options.draggableZoom && (f = l(b.x, b.y)), Math.abs(b.y) > Math.abs(b.x) && f.y ? a.preventDefault() : Math.abs(b.x) >= Math.abs(b.y) && f.x && a.preventDefault();
        },
            l = function l(c, d) {
          var e = parseFloat(parseFloat(a) + c),
              f = parseFloat(parseFloat(b) + d),
              h = g.$element.find('img.active'),
              i = h.eq(0),
              j = i.position(),
              k = j.left,
              l = j.top,
              m = h.eq(-1),
              n = m.position(),
              o = m.parent(),
              p = g.$dragNavCrop,
              q = p.position(),
              r = { x: k + e < 0 && n.left + m.width() + e > o.outerWidth(), y: l + f < 0 && n.top + m.height() + f > o.outerHeight() };return r.x && (h.css({ 'margin-left': e }), p.css({ left: -(k + e) / h.width() * 100 + '%' })), r.y && (h.css({ 'margin-top': f }), p.css({ top: -(l + f) / h.height() * 100 + '%' })), q && g.$dragNavCropImg.css({ 'margin-left': -q.left, 'margin-top': -q.top }), r;
        };this.refreshDragNavCropSize(), this.jGallery.options.draggableZoom && (this.refreshCursor(), window.addEventListener('resize', this.refreshCursor.bind(this))), this.$element.on({ mousedown: function mousedown(a) {
            i(a), g.slideshowPause();
          }, touchstart: function touchstart(a) {
            i(a.originalEvent.touches[0]), g.slideshowPause();
          }, mouseup: function mouseup() {
            j();
          }, touchend: function touchend() {
            j();
          } });
      }, refreshCursor: function refreshCursor() {
        this.$element.get(0).style.cursor = this.canDrag() ? 'move' : 'default';
      }, canDrag: function canDrag() {
        var a = this.$element.get(0),
            b = a.querySelector('img.active');return b && this.jGallery.options.draggableZoom && (b.clientWidth > a.clientWidth || b.clientHeight > a.clientHeight);
      }, refreshContainerSize: function refreshContainerSize() {
        var a = this.jGallery.isSlider() ? 0 : this.$container.find('.nav-bottom').outerHeight(),
            b = !this.jGallery.isSlider() && !this.thumbnails.getElement().is('.hidden'),
            c = b ? this.jGallery.options.thumbnailsPosition : '';this.$container.css({ width: b && this.thumbnails.isVertical() ? this.$jGallery.width() - this.thumbnails.getElement().outerWidth(!0) : 'auto', height: b && this.thumbnails.isHorizontal() ? this.$jGallery.height() - this.thumbnails.getElement().outerHeight(!0) - a : this.$jGallery.height() - a, 'margin-top': 'top' === c ? this.thumbnails.getElement().outerHeight(!0) : 0, 'margin-left': 'left' === c ? this.thumbnails.getElement().outerWidth(!0) : 0, 'margin-right': 'right' === c ? this.thumbnails.getElement().outerWidth(!0) : 0 }), this.jGallery.options.draggableZoom && this.refreshDragNavCropSize();
      }, refreshSize: function refreshSize() {
        this.thumbnails.isFullScreen() || (this.refreshContainerSize(), 'original' === this.jGallery.options.zoomSize ? this.original() : 'fill' === this.jGallery.options.zoomSize ? this.fill() : this.fit(), this.jGallery.options.draggableZoom && (this.refreshDragNavCropSize(), this.refreshDragNavVisibility()), this.$element.addClass('visible'), this.refreshCursor());
      }, refreshDragNavCropSize: function refreshDragNavCropSize() {
        var a,
            b,
            c = this.$element.find('img.active');this.$dragNavCrop.css({ width: this.$element.width() / c.width() * 100 + '%', height: this.$element.height() / c.height() * 100 + '%' }), a = c.attr('data-width') < this.$container.outerWidth() ? 0 : (this.$dragNav.width() - this.$dragNavCrop.width()) / 2, b = c.attr('data-height') < this.$container.outerHeight() ? 0 : (this.$dragNav.height() - this.$dragNavCrop.height()) / 2, this.$dragNavCrop.css({ left: a, top: b }), this.$dragNavCropImg.length && this.$dragNavCropImg.css({ 'margin-left': -a, 'margin-top': -b });
      }, changeSize: function changeSize() {
        if ('fit' === this.jGallery.options.zoomSize) this.jGallery.options.zoomSize = 'fill';else if ('fill' === this.jGallery.options.zoomSize) {
          var a = this.$element.find('img.active').eq(0);this.$element.outerWidth().toString() === a.attr('data-width') ? this.jGallery.options.zoomSize = 'fit' : this.jGallery.options.zoomSize = 'original';
        } else 'original' === this.jGallery.options.zoomSize && (this.jGallery.options.zoomSize = 'fit');this.refreshSize(), this.$container.attr('data-size', this.jGallery.options.zoomSize);
      }, original: function original() {
        var a = this.$element.find('img.active');this.advancedAnimation.setPositionParts(), this.setImgSizeForOriginal(a), this.setImgSizeForOriginal(this.$element.find('.pt-page.init img')), a.attr('data-width') <= this.$element.outerWidth() && a.attr('data-height') <= this.$element.outerHeight() ? this.$resize.addClass('fa-search-plus').removeClass('fa-search-minus') : this.$resize.addClass('fa-search-minus').removeClass('fa-search-plus');
      }, fit: function fit() {
        var a = this.$element.find('img.active').add(this.$element.find('.pt-page.init img'));this.advancedAnimation.setPositionParts(), this.setImgSizeForFit(a.filter('.active')), this.setImgSizeForFit(a.filter(':not( .active )')), this.$resize.addClass('fa-search-plus').removeClass('fa-search-minus');
      }, fill: function fill() {
        var a = this.$element.find('img.active');this.setImgSizeForFill(a), this.setImgSizeForFill(this.$element.find('.pt-page.init img')), this.advancedAnimation.setPositionParts(), a.attr('data-width') > a.width() && a.attr('data-height') > a.height() ? this.$resize.addClass('fa-search-plus').removeClass('fa-search-minus') : this.$resize.addClass('fa-search-minus').removeClass('fa-search-plus');
      }, setImgSizeForOriginal: function setImgSizeForOriginal(a) {
        a.css({ width: a.attr('data-width'), height: a.attr('data-height'), 'min-width': 0, 'min-height': 0, 'max-width': 'none', 'max-height': 'none' }), a.css({ 'margin-top': -a.height() / 2, 'margin-left': -a.width() / 2 });
      }, setImgSizeForFit: function setImgSizeForFit(a) {
        var b = this.jGallery.isSlider() ? 0 : this.$container.find('.nav-bottom').outerHeight(),
            c = !this.jGallery.isSlider() && !this.thumbnails.getElement().is('.hidden');a.css({ width: 'auto', height: 'auto', 'min-width': 0, 'min-height': 0, 'max-width': c && this.thumbnails.isVertical() ? this.$jGallery.width() - this.thumbnails.getElement().outerWidth(!0) : this.$jGallery.width(), 'max-height': c && this.thumbnails.isHorizontal() ? this.$jGallery.height() - this.thumbnails.getElement().outerHeight(!0) - b : this.$jGallery.height() - b }), a.width() / a.height() / this.jGallery.getCanvasRatioWidthToHeight() < 1 ? a.css({ width: 'auto', height: c && this.thumbnails.isHorizontal() ? this.$jGallery.height() - this.thumbnails.getElement().outerHeight(!0) - b : this.$jGallery.height() - b }) : a.css({ width: c && this.thumbnails.isVertical() ? this.$jGallery.width() - this.thumbnails.getElement().outerWidth(!0) : this.$jGallery.width(), height: 'auto' }), a.css({ 'margin-top': -a.height() / 2, 'margin-left': -a.width() / 2 });
      }, setImgSizeForFill: function setImgSizeForFill(a) {
        var b = this.jGallery.isSlider() ? 0 : this.$container.find('.nav-bottom').outerHeight(),
            c = !this.jGallery.isSlider() && !this.thumbnails.getElement().is('.hidden');a.css({ width: 'auto', height: 'auto', 'max-width': 'none', 'max-height': 'none', 'min-width': 0, 'min-height': 0 }), a.width() / a.height() / this.jGallery.getCanvasRatioWidthToHeight() > 1 ? a.css({ width: 'auto', height: c && this.thumbnails.isHorizontal() ? this.$jGallery.height() - this.thumbnails.getElement().outerHeight(!0) - b : this.$jGallery.height() - b }) : a.css({ width: c && this.thumbnails.isVertical() ? this.$jGallery.width() - this.thumbnails.getElement().outerWidth(!0) : this.$jGallery.width(), height: 'auto' }), a.css({ 'min-width': c && this.thumbnails.isVertical() ? this.$jGallery.width() - this.thumbnails.getElement().outerWidth(!0) : this.$jGallery.width(), 'min-height': c && this.thumbnails.isHorizontal() ? this.$jGallery.height() - this.thumbnails.getElement().outerHeight(!0) - b : this.$jGallery.height() - b }), a.css({ 'margin-top': -a.height() / 2, 'margin-left': -a.width() / 2 });
      }, isAddedToLoad: function isAddedToLoad(a) {
        return this.$element.find('img').filter('[src="' + a.attr('href') + '"]').length > 0;
      }, isLoaded: function isLoaded(a) {
        var b = this.$element.find('img').filter('[src="' + a.attr('href') + '"]').get(0);if (b) return this.imgIsLoaded(b);
      }, imgIsLoaded: function imgIsLoaded(a) {
        return a.complete && a.naturalWidth > 0;
      }, refreshNav: function refreshNav() {
        var a = this.thumbnails.getElement().find('div.active a.active');1 === a.prev('a').length ? this.$btnPrev.removeClass('hidden') : this.$btnPrev.addClass('hidden'), 1 === a.next('a').length ? this.$btnNext.removeClass('hidden') : this.$btnNext.addClass('hidden');
      }, slideshowStop: function slideshowStop() {
        this.slideshowPause(), this.jGallery.progress.clear();
      }, slideshowPause: function slideshowPause() {
        this.jGallery.progress.pause(), this.$slideshow.removeClass('fa-pause').addClass('fa-play'), this.booSlideshowPlayed = !1, this.jGallery.options.slideshowCanRandom && this.$random.hide();
      }, slideshowPlay: function slideshowPlay() {
        this.booLoadingInProgress || this.booSlideshowPlayed || (this.booSlideshowPlayed = !0, this.$slideshow.removeClass('fa-play').addClass('fa-pause'), this.slideshowSetTimeout(), this.jGallery.options.slideshowCanRandom && this.$random.show());
      }, slideshowPlayPause: function slideshowPlayPause() {
        this.$slideshow.is('.fa-play') ? this.slideshowPlay() : this.slideshowPause();
      }, slideshowSetTimeout: function slideshowSetTimeout() {
        var a = this;this.jGallery.progress.start(this.$container.width(), function () {
          a.jGallery.progress.clear(), a.jGallery.options.slideshowRandom ? a.showRandomPhoto() : a.showNextPhotoLoop();
        });
      }, slideshowRandomToggle: function slideshowRandomToggle() {
        this.jGallery.options.slideshowRandom ? (this.$random.removeClass('active'), this.jGallery.options.slideshowRandom = !1) : (this.$random.addClass('active'), this.jGallery.options.slideshowRandom = !0);
      }, showNextPhotoLoop: function showNextPhotoLoop() {
        var a = this.thumbnails.$a.filter('.active').next('a');0 === a.length && (a = this.thumbnails.$albums.filter('.active').find('a').eq(0)), this.showPhoto(a);
      }, showRandomPhoto: function showRandomPhoto() {
        var a = this.thumbnails.$albums.filter('.active').find('a:not(.active)');this.showPhoto(a.eq(Math.floor(Math.random() * a.length)));
      }, showPrevPhoto: function showPrevPhoto() {
        var a = this.thumbnails.$a.filter('.active').prev('a');1 === a.length && this.showPhoto(a);
      }, showNextPhoto: function showNextPhoto() {
        var a = this.thumbnails.$a.filter('.active').next('a');1 === a.length && this.showPhoto(a);
      }, showPhotoInit: function showPhotoInit() {
        this.jGallery.init();
      }, showPhoto: function showPhoto(a, b) {
        var c,
            e,
            g,
            h,
            i = this,
            j = a.children('img'),
            k = a.next();k.length > 0 && (i.isAddedToLoad(k) || this.appendPhoto(k));var l = a.prev();if (l.length > 0 && (i.isAddedToLoad(l) || this.appendPhoto(l)), this.jGallery.initialized() || this.showPhotoInit(), !this.booLoadingInProgress) {
          if (this.booLoadingInProgress = !0, h = this.jGallery.options[a.nextAll('.active').length > 0 ? 'transitionBackward' : 'transition'], 'random' === h ? this.setRandomTransition() : 'auto' === h ? (g = d[f[this.jGallery.options.transition]], this.advancedAnimation.setHideEffect(g[0]), this.advancedAnimation.setShowEffect(g[1])) : (g = d[h], this.advancedAnimation.setHideEffect(g[0]), this.advancedAnimation.setShowEffect(g[1])), this.$element.find('.pt-page.init').remove(), this.jGallery.options.showPhoto(a, j), this.jGallery.$element.is(':not(:visible)') && this.jGallery.show(), this.thumbnails.changeViewToBar(), this.jGallery.booIsAlbums && '' === this.jGallery.iconChangeAlbum.getTitle() && (e = a.parents('.album').eq(0).attr('data-jgallery-album-title'), this.jGallery.iconChangeAlbum.setTitle(e), this.jGallery.iconChangeAlbum.$element.find('[data-jgallery-album-title="' + e + '"]').addClass('active'), a.parents('.album').addClass('active').siblings('.album').removeClass('active')), this.thumbnails.setActiveAlbum(this.thumbnails.$albums.filter('[data-jgallery-album-title="' + a.parents('[data-jgallery-album-title]').attr('data-jgallery-album-title') + '"]')), this.thumbnails.setActiveThumb(a), this.$element.find('img.active').attr('src') === a.attr('href')) return this.booLoadingInProgress = !1, void this.setJGalleryColoursForActiveThumb();a.is('[link]') ? (this.$element.addClass('is-link'), a.is('[target="_blank"]') ? this.$element.attr('onclick', 'window.open("' + a.attr('link') + '")') : this.$element.attr('onclick', 'window.location="' + a.attr('link') + '"')) : (this.$element.removeClass('is-link'), this.$element.removeAttr('onclick')), this.refreshNav(), this.jGallery.options.title && this.$title.addClass('after fade'), c = i.isLoaded(a), c || (i.jGallery.options.preloadAll && !i.booLoadedAll ? this.appendAllPhotos() : this.isAddedToLoad(a) || this.appendPhoto(a)), this.$element.find('img.active').addClass('prev-img'), i.$container.find('img.active').removeClass('active'), i.$container.find('[src="' + a.attr('href') + '"]').addClass('active'), i.jGallery.options.title && j.is('[alt]') && i.$title.removeClass('after').addClass('before'), !c || i.jGallery.options.preloadAll && !i.booLoadedAll ? (i.booLoadedAll = !0, i.$container.overlay({ show: !0, showLoader: !0, showProgress: i.jGallery.options.preloadAll, resetProgress: i.jGallery.options.preloadAll }), i.jGallery.options.beforeLoadPhoto(a, j), i.loadPhoto(i.$element, a, b)) : i.showPhotoSuccess(a, j, b);
        }
      }, appendPhoto: function appendPhoto(a) {
        this.$element.find('.pt-part').append('                <div class="jgallery-container pt-page">                    <div class="pt-item"><img src="' + a.attr('href') + '" /></div>                </div>');
      }, appendAllPhotos: function appendAllPhotos() {
        var a = this;this.jGallery.options.preloadAll && (this.thumbnails.$a.each(function () {
          var b = i(this);a.isAddedToLoad(b) || a.$element.find('.pt-part').append('<div class="jgallery-container pt-page"><div class="pt-item"><img src="' + b.attr('href') + '" /></div></div>');
        }), this.appendInitPhoto(this.thumbnails.$a.eq(-1)));
      }, appendInitPhoto: function appendInitPhoto(a) {
        1 === a.length && this.$element.find('.pt-part').append('                <div class="jgallery-container pt-page pt-page-current pt-page-ontop init" style="visibility: hidden;">                    <div class="pt-item"><img src="' + a.attr('href') + '" class="active loaded" /></div>                </div>');
      }, loadPhoto: function loadPhoto(a, b, c) {
        var d = this,
            e = b.children('img'),
            f = 0,
            g = a.find('.pt-part').eq(0);(this.jGallery.options.preloadAll ? g : g.find('img.active')).jLoader({ interval: 500, skip: '.loaded', start: function start() {}, success: function success() {
            a.find('img').each(function () {
              var a = i(this);d.imgIsLoaded(a.get(0)) && a.addClass('loaded');
            }), d.$container.overlay({ hide: !0, hideLoader: !0 }), d.showPhotoSuccess(b, e, c);
          }, progress: function progress(a) {
            d.jGallery.options.preloadAll && (f = a.percent, d.$container.find('.overlay .imageLoaderPositionAbsolute').find('.progress-value').html(f));
          } });
      }, showPhotoSuccess: function showPhotoSuccess(a, b, d) {
        var e,
            f = this.$element.find('img.active');d = i.extend({}, { historyPushState: !0 }, d), f.is(':not([data-width])') && (e = new Image(), e.src = f.attr('src'), f.attr('data-width', e.width), f.attr('data-height', e.height)), this.jGallery.options.title && b.attr('alt') ? (this.$title.html(b.attr('alt')).removeClass('before').removeClass('after'), this.jGallery.$element.addClass('has-title')) : this.jGallery.$element.removeClass('has-title'), this.setJGalleryColoursForActiveThumb(), this.$element.find('.pt-page.init').css({ visibility: 'visible' }), this.$element.find('img.prev-img').removeClass('prev-img'), this.advancedAnimation.show(f.eq(0).parent().parent(), { animation: 1 === this.$element.find('.pt-part').eq(0).find('.pt-page-current:not(.pt-page-prev)').length }), this.refreshSize(), this.thumbnails.refreshNavigation(), this.booSlideshowPlayed && this.slideshowSetTimeout(), this.jGallery.options.afterLoadPhoto(a, b), this.booLoadingInProgress = !1, this.jGallery.options.autostart && this.jGallery.options.slideshowAutostart && this.jGallery.options.slideshow && (this.jGallery.options.slideshowAutostart = !1, this.slideshowPlay()), this.jGallery.options.draggableZoom && (this.$dragNav.html('<img src="' + f.attr('src') + '" class="bg">                    <div class="crop"><img src="' + f.attr('src') + '"></div>'), this.$dragNavCrop = this.$dragNav.find('.crop'), this.$dragNavCropImg = this.$dragNavCrop.find('img'), this.refreshDragNavCropSize()), d.historyPushState && this.jGallery.options.browserHistory && c({ path: f.attr('src') });
      }, showPhotoByPath: function showPhotoByPath(a) {
        var b = this.thumbnails.$albums.filter('.active').find('a[href="' + a + '"]');0 === b.length && (b = this.thumbnails.$a.filter('a[href="' + a + '"]').eq(0)), 0 !== b.length && this.showPhoto(b, { historyPushState: !1 });
      }, setJGalleryColoursForActiveThumb: function setJGalleryColoursForActiveThumb() {
        var a = this.thumbnails.$a.filter('.active').find('img');this.jGallery.setColours({ strBg: a.is('[data-jgallery-bg-color]') ? a.attr('data-jgallery-bg-color') : this.jGallery.options.backgroundColor, strText: a.is('[data-jgallery-bg-color]') ? a.attr('data-jgallery-text-color') : this.jGallery.options.textColor });
      }, setTransition: function setTransition(a) {
        this.jGallery.options.hideEffect = d[a][0], this.jGallery.options.showEffect = d[a][1], this.advancedAnimation.setHideEffect(this.jGallery.options.hideEffect), this.advancedAnimation.setShowEffect(this.jGallery.options.showEffect);
      }, setRandomTransition: function setRandomTransition() {
        var a;this.$element.find('.pt-page').removeClass(this.jGallery.options.hideEffect).removeClass(this.jGallery.options.showEffect), a = Math.floor(Math.random() * e.length), this.jGallery.options.hideEffect = e[a][0], this.jGallery.options.showEffect = e[a][1], this.advancedAnimation.setHideEffect(this.jGallery.options.hideEffect), this.advancedAnimation.setShowEffect(this.jGallery.options.showEffect);
      }, unmarkActive: function unmarkActive() {
        this.$element.find('img.active').removeClass('active');
      }, changeMode: function changeMode() {
        var a = this.jGallery.options.mode;'slider' !== a && ('standard' === a ? this.goToFullScreenMode() : 'full-screen' === a && this.goToStandardMode(), this.jGallery.iconChangeAlbum instanceof h && this.jGallery.iconChangeAlbum.refreshMenuHeight());
      }, goToFullScreenMode: function goToFullScreenMode() {
        j.css({ overflow: 'hidden' }), this.jGallery.$element.removeClass('jgallery-standard').addClass('jgallery-full-screen').css({ width: 'auto', height: 'auto' }), this.$changeMode.removeClass('fa-expand').addClass('fa-compress'), this.jGallery.options.mode = 'full-screen', this.jGallery.refreshDimensions();
      }, goToStandardMode: function goToStandardMode() {
        j.css({ overflow: 'visible' }), this.jGallery.$element.removeClass('jgallery-full-screen').addClass('jgallery-standard').css({ width: this.jGallery.options.width, height: this.jGallery.options.height }), this.$changeMode.removeClass('fa-compress').addClass('fa-expand'), this.jGallery.options.mode = 'standard', this.jGallery.refreshDimensions();
      } }, k;
  }(k, j, l, f, g, h, p, q),
      w = function (a, b, c, d, e, f, g, h, i, j, k, l, m, n, o) {
    var p = jQuery,
        q = p('html'),
        r = p('head'),
        s = p('body'),
        t = p(window);p.fn.outerHtml = a;var u = function u(a, b, c) {
      var f = this;b && !a.is('[data-jgallery-id]') && (this.$this = a, this.intId = b, this.$this.attr('data-jgallery-id', this.intId), this.overrideOptions(c), this.booIsAlbums = this.options.items && this.options.items[0].images || a.find('.album:has(a:has(img))').length > 1, this.options.disabledOnIE8AndOlder && d() || this.init({ success: function success() {
          f.options.browserHistory && f.browserHistory(), f.options.autostart && f.autostart(), e(), q.on({ keydown: function keydown(a) {
              if (f.$element.is(':visible')) {
                if (27 === a.which) {
                  if (a.preventDefault(), f.thumbnails.getElement().is('.full-screen')) return f.thumbnails.changeViewToBar(), void f.zoom.refreshSize();f.isFullScreenMode() && !f.canClose() && f.zoom.changeMode(), f.hide();
                }37 === a.which && (a.preventDefault(), f.zoom.slideshowStop(), f.zoom.showPrevPhoto()), 39 === a.which && (a.preventDefault(), f.zoom.slideshowStop(), f.zoom.showNextPhoto());
              }
            } });
        } }));
    };return u.prototype = { isFullScreenMode: function isFullScreenMode() {
        return 'full-screen' === this.options.mode;
      }, canClose: function canClose() {
        return this.options.canClose;
      }, template: { html: '<div class="jgallery" style="display: none;">                        <div class="jgallery-thumbnails hidden">                            <div class="jgallery-container"><div class="jgallery-container-inner"></div></div>                            <span class="prev jgallery-btn"><span class="fa fa-chevron-left ico"></span></span>                            <span class="next jgallery-btn"><span class="fa fa-chevron-right ico"></span></span>                        </div>                        <div class="zoom-container">                            <div class="zoom before pt-perspective"></div>                            <div class="drag-nav hide"></div>                            <div class="left"></div>                            <div class="right"></div>                            <span class="fa fa-chevron-left prev jgallery-btn jgallery-btn-large"></span>                            <span class="fa fa-chevron-right next jgallery-btn jgallery-btn-large"></span>                            <span class="progress"></span>                            <div class="nav">                                <span class="fa resize jgallery-btn jgallery-btn-small" tooltip-position="bottom right"></span>                                <span class="fa change-mode jgallery-btn jgallery-btn-small" tooltip-position="bottom right"></span>                                <span class="fa fa-times jgallery-close jgallery-btn jgallery-btn-small" tooltip-position="bottom right"></span>                            </div>                            <div class="nav-bottom">                                <div class="icons">                                    <span class="fa fa-play slideshow jgallery-btn jgallery-btn-small"></span>                                    <span class="fa fa-random random jgallery-btn jgallery-btn-small inactive"></span>                                    <span class="fa fa-th full-screen jgallery-btn jgallery-btn-small"></span>                                    <span class="fa fa-ellipsis-h minimalize-thumbnails jgallery-btn jgallery-btn-small"></span>                                </div>                                <div class="title before"></div>                            </div>                        </div>                    </div>', done: function done(a) {
          a(this.html);
        } }, initialized: function initialized() {
        return this.$this.is('[data-jgallery-id]');
      }, update: function update(a) {
        var b = this;this.template.done(function () {
          b.overrideOptions(a), b.options.disabledOnIE8AndOlder && d() || (b.booIsAlbums = b.$this.find('.album:has(a:has(img))').length > 1, b.zoom.update(), b.thumbnails.init(), b.setUserOptions(), b.reloadThumbnails(), b.refreshDimensions());
        });
      }, overrideOptions: function overrideOptions(a) {
        var b = void 0 !== a && void 0 !== a.mode;this.options = p.extend({}, f, this.options), b && 'full-screen' === a.mode ? this.options = p.extend({}, this.options, g, a, i) : b && 'slider' === a.mode ? this.options = p.extend({}, this.options, h, a, j) : this.options = p.extend({}, this.options, a);
      }, reloadThumbnails: function reloadThumbnails() {
        new n(this, { thumbsHidden: !1 }), this.generateAlbumsDropdown(), this.thumbnails.reload();
      }, setVariables: function setVariables() {
        this.$element = p('.jgallery').filter('[data-jgallery-id="' + this.intId + '"]'), this.progress = new l(this.$element.find('.zoom-container').children('.progress'), this), this.zoom = new o(this), this.thumbnails = new m(this), this.zoom.setThumbnails(this.thumbnails);
      }, show: function show() {
        this.options.items || this.$this.hide(), t.on('resize', { jGallery: this }, this.windowOnResize), 'full-screen' === this.options.mode && (this.bodyOverflowBeforeShow = s.css('overflow'), s.css({ overflow: 'hidden' })), this.$element.not(':visible').removeClass('hidden').stop(!1, !0).fadeIn(500), this.zoom.refreshContainerSize(), this.zoom.$title.removeClass('hidden'), this.options.showGallery(), this.iconChangeAlbum instanceof k && this.iconChangeAlbum.refreshMenuHeight(), e();
      }, hide: function hide(a) {
        var c = this;this.options.canClose && (a = p.extend({}, { historyPushState: !0 }, a), this.$element.filter(':visible').stop(!1, !0).addClass('hidden').fadeOut(500, function () {
          'full-screen' === c.options.mode && s.css({ overflow: c.bodyOverflowBeforeShow }), e();
        }), this.zoom.booLoadingInProgress = !1, clearTimeout(this.zoom.showPhotoTimeout), this.zoom.$title.addClass('hidden'), this.zoom.$btnPrev.addClass('hidden'), this.zoom.$btnNext.addClass('hidden'), this.zoom.slideshowPause(), this.zoom.advancedAnimation.hideActive(), this.zoom.unmarkActive(), t.off('resize', this.windowOnResize), this.$this.show(), a.historyPushState && this.options.browserHistory && b(), this.options.closeGallery());
      }, autostart: function autostart() {
        var a, b;this.$element.is(':visible') || (this.booIsAlbums ? (a = this.thumbnails.getElement().find('.album').eq(this.options.autostartAtAlbum - 1), 0 === a.length && (a = this.thumbnails.getElement().find('.album').eq(0))) : a = this.thumbnails.getElement(), b = a.find('a').eq(this.options.autostartAtImage - 1), 0 === b.length && (b = a.find('a').eq(0)), b.trigger('click'));
      }, browserHistory: function browserHistory() {
        function a() {
          var a;if (document.location.hash) switch (a = document.location.hash.replace('#', '')) {case '':
              b.hide({ historyPushState: !1 });break;default:
              b.zoom.showPhotoByPath(a);}
        }var b = this,
            c = window.onpopstate;window.onpopstate = function () {
          'function' == typeof c && c(), a();
        }, this.options.autostart && a();
      }, generateAlbumsDropdown: function generateAlbumsDropdown() {
        var a = this;this.$element.find('.change-album').remove(), this.booIsAlbums && (this.zoom.$container.find('.nav-bottom > .icons').append('                <span class="fa fa-list-ul change-album jgallery-btn jgallery-btn-small" tooltip="' + a.options.tooltipSeeOtherAlbums + '">                    <span class="menu jgallery-btn"></span>                    <span class="title"></span>                </span>            '), this.iconChangeAlbum = new k(a.zoom.$container.find('.change-album'), this), this.iconChangeAlbum.clearMenu(), this.thumbnails.$albums.each(function () {
          var b = p(this).attr('data-jgallery-album-title');a.iconChangeAlbum.appendToMenu('<span class="item" data-jgallery-album-title="' + b + '">' + b + '</span>');
        }), this.thumbnails.getElement().append(this.iconChangeAlbum.getElement().outerHtml()), this.iconChangeAlbum = new k(this.iconChangeAlbum.getElement().add(this.thumbnails.getElement().children(':last-child')), this), this.iconChangeAlbum.bindEvents(this));
      }, init: function init(a) {
        var b = this;a = p.extend({ success: function success() {} }, a), r.append('<style type="text/css" class="colours" data-jgallery-id="' + this.intId + '"></style>'), this.options.initGallery(), this.generateHtml({ success: function success() {
            new n(b), b.setVariables(), b.thumbnails.init(), b.thumbnails.getElement().append('<span class="fa fa-times jgallery-btn jgallery-close jgallery-btn-small"></span>'), b.generateAlbumsDropdown(), b.setUserOptions(), 'fit' !== b.options.zoomSize && 'original' !== b.options.zoomSize || b.zoom.$resize.addClass('fa-search-plus'), 'fill' === b.options.zoomSize && b.zoom.$resize.addClass('fa-search-minus'), c() || b.$element.addClass('text-shadow'), b.thumbnails.refreshNavigation(), b.zoom.refreshNav(), b.zoom.refreshSize(), b.$this.on('click', 'a:has(img)', function (a) {
              var c = p(this);a.preventDefault(), b.zoom.showPhoto(c);
            }), b.thumbnails.$element.on('click', 'a', function (a) {
              var c = p(this);a.preventDefault(), c.is(':not(.active)') ? (b.zoom.slideshowStop(), b.zoom.showPhoto(c)) : b.thumbnails.isFullScreen() && (b.thumbnails.changeViewToBar(), b.zoom.refreshSize());
            }), b.zoom.$btnPrev.add(b.zoom.$container.find('.left')).on({ click: function click() {
                b.zoom.slideshowStop(), b.zoom.showPrevPhoto();
              } }), b.zoom.$btnNext.add(b.zoom.$container.find('.right')).on({ click: function click() {
                b.zoom.slideshowStop(), b.zoom.showNextPhoto();
              } }), b.zoom.$container.find('.jgallery-close').on({ click: function click() {
                b.hide();
              } }), b.zoom.$random.on({ click: function click() {
                b.zoom.slideshowRandomToggle();
              } }), b.zoom.$resize.on({ click: function click() {
                b.zoom.changeSize(), b.zoom.slideshowPause();
              } }), b.zoom.$changeMode.on({ click: function click() {
                b.zoom.changeMode();
              } }), b.zoom.$slideshow.on({ click: function click() {
                b.zoom.slideshowPlayPause();
              } }), b.zoom.$container.find('.minimalize-thumbnails').on({ click: function click() {
                b.thumbnails.toggle(), b.zoom.refreshSize();
              } }), b.thumbnails.bindEvents(), a.success(), b.options.hideThumbnailsOnInit && b.zoom.$container.find('.minimalize-thumbnails').addClass('inactive');
          } }), this.refreshCssClassJGalleryMobile();
      }, isSlider: function isSlider() {
        return 'slider' === this.options.mode;
      }, windowOnResize: function windowOnResize(a) {
        var b = a.data.jGallery;b.refreshThumbnailsVisibility(), b.refreshCssClassJGalleryMobile();
      }, refreshCssClassJGalleryMobile: function refreshCssClassJGalleryMobile() {
        this.isMobile() ? this.$jgallery.addClass('jgallery-mobile') : this.$jgallery.removeClass('jgallery-mobile');
      }, refreshDimensions: function refreshDimensions() {
        this.zoom.refreshSize(), this.iconChangeAlbum instanceof k && this.iconChangeAlbum.refreshMenuHeight(), this.thumbnails.refreshNavigation();
      }, getCanvasRatioWidthToHeight: function getCanvasRatioWidthToHeight() {
        var a, b;return this.thumbnails.isHorizontal() ? (a = this.$element.width(), b = this.$element.height() - this.thumbnails.getElement().outerHeight(!0)) : this.thumbnails.isVertical() ? (a = this.$element.width() - this.thumbnails.getElement().outerWidth(!0), b = this.$element.height()) : (a = this.$element.width(), b = this.$element.height()), a / b;
      }, hideThumbnailsBar: function hideThumbnailsBar() {
        this.thumbnails.getElement().addClass('hidden'), this.zoom.$container.find('.minimalize-thumbnails').hide();
      }, showThumbnailsBar: function showThumbnailsBar() {
        this.thumbnails.getElement().removeClass('hidden'), this.options.canMinimalizeThumbnails && this.options.thumbnails ? this.zoom.$container.find('.minimalize-thumbnails').show() : this.zoom.$container.find('.minimalize-thumbnails').hide();
      }, refreshThumbnailsVisibility: function refreshThumbnailsVisibility() {
        this.isMobile() ? this.options.thumbnailsHideOnMobile && this.hideThumbnailsBar() : this.options.thumbnails ? this.showThumbnailsBar() : this.hideThumbnailsBar(), this.refreshDimensions();
      }, isMobile: function isMobile() {
        return t.width() <= this.options.maxMobileWidth;
      }, setUserOptions: function setUserOptions() {
        var a = this.options,
            b = a.mode,
            c = 'full-screen' === b ? 'auto' : a.width,
            d = 'full-screen' === b ? 'auto' : a.height;this.refreshAttrClasses(), this.options.canZoom ? this.zoom.$resize.show() : this.zoom.$resize.hide(), this.options.canChangeMode ? this.zoom.$changeMode.show() : this.zoom.$changeMode.hide(), 'standard' === this.options.mode ? this.zoom.$changeMode.removeClass('fa-compress').addClass('fa-expand') : this.zoom.$changeMode.removeClass('fa-expand').addClass('fa-compress'), this.options.canClose ? this.zoom.$container.find('.jgallery-close').show() : this.zoom.$container.find('.jgallery-close').hide(), this.refreshThumbnailsVisibility(), this.zoom.refreshSize(), this.options.slideshow ? this.zoom.$slideshow.show() : this.zoom.$slideshow.hide(), this.options.slideshow && this.options.slideshowCanRandom && this.options.slideshowAutostart ? this.zoom.$random.show() : this.zoom.$random.hide(), this.options.slideshow && this.options.slideshowCanRandom && this.options.slideshowRandom ? this.zoom.$random.addClass('active') : this.zoom.$random.removeClass('active'), this.options.thumbnailsFullScreen && this.options.thumbnails ? this.zoom.$container.find('.full-screen').show() : this.zoom.$container.find('.full-screen').hide(), this.options.hideThumbnailsOnInit && this.options.thumbnails ? this.thumbnails.hide() : this.thumbnails.show(), this.options.titleExpanded ? this.zoom.$title.addClass('expanded') : this.zoom.$title.removeClass('expanded'), this.setColours({ strBg: this.options.backgroundColor, strText: this.options.textColor }), this.options.tooltips ? this.$jgallery.addClass('jgallery-tooltips') : this.$jgallery.removeClass('jgallery-tooltips'), this.$jgallery.css({ width: c, height: d }), this.options.draggableZoomHideNavigationOnMobile ? this.$jgallery.addClass('jgallery-hide-draggable-navigation-on-mobile') : this.$jgallery.removeClass('jgallery-hide-draggable-navigation-on-mobile');
      }, refreshAttrClasses: function refreshAttrClasses() {
        var a = this,
            b = ['standard', 'full-screen', 'slider'];p.each(b, function (b, c) {
          a.$jgallery.removeClass('jgallery-' + c);
        }), this.$jgallery.addClass('jgallery-' + this.options.mode);
      }, setColours: function setColours(a) {
        r.find('style[data-jgallery-id="' + this.intId + '"].colours').html(this.getCssForColours(a));
      }, generateHtml: function generateHtml(a) {
        var b = this;a = p.extend({}, { success: function success() {} }, a), this.template.done(function (c) {
          !function () {
            var a = b.options,
                d = a.mode;a.items ? b.$jgallery = b.$this.append(c).children(':last-child') : 'full-screen' === d ? b.$jgallery = b.$this.after(c).next() : (a.autostart && b.$this.hide(), b.$jgallery = b.$this.after(c).next()), b.$jgallery.addClass('jgallery-' + d).attr('data-jgallery-id', b.intId), b.$jgallery.find('.fa.slideshow').attr('tooltip', a.tooltipSlideshow), b.$jgallery.find('.fa.resize').attr('tooltip', a.tooltipZoom), b.$jgallery.find('.fa.change-mode').attr('tooltip', a.tooltipFullScreen), b.$jgallery.find('.fa.jgallery-close').attr('tooltip', a.tooltipClose), b.$jgallery.find('.fa.random').attr('tooltip', a.tooltipRandom), b.$jgallery.find('.fa.full-screen').attr('tooltip', a.tooltipSeeAllPhotos), b.$jgallery.find('.fa.minimalize-thumbnails').attr('tooltip', a.tooltipToggleThumbnails);
          }(), a.success();
        });
      }, getCssForColours: function getCssForColours(a) {
        a = p.extend({ strBg: 'rgb( 0, 0, 0 )', strText: 'rgb( 255, 255, 255 )' }, a);var b, c, d;return 'function' == typeof tinycolor ? (b = tinycolor(a.strText).toRgb(), c = tinycolor(a.strBg).toRgb(), c.r + c.g + c.b > 375 ? (c = tinycolor.darken(a.strBg).toRgb(), d = tinycolor(a.strBg).toRgb()) : (c = tinycolor(a.strBg).toRgb(), d = tinycolor.lighten(a.strBg).toRgb())) : (c = { r: 230, g: 230, b: 230 }, d = { r: 255, g: 255, b: 255 }, b = { r: 0, g: 0, b: 0 }), '                .jgallery[data-jgallery-id="' + this.intId + '"] {                  background: rgb(' + c.r + ',' + c.g + ', ' + c.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] [tooltip]:after {                  background: rgba(' + b.r + ',' + b.g + ', ' + b.b + ', .9);                  color: rgb(' + c.r + ',' + c.g + ', ' + c.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-btn {                  color: rgb(' + b.r + ',' + b.g + ', ' + b.b + ');                  text-shadow: 0 0 1px rgb(' + c.r + ',' + c.g + ', ' + c.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-btn.active {                  color: rgb(' + b.r + ',' + b.g + ', ' + b.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-btn:hover {                  text-shadow: none;                  text-shadow: 0 0 .15em rgba(' + b.r + ',' + b.g + ', ' + b.b + ',.75), 0 0 .45em rgba(' + b.r + ',' + b.g + ', ' + b.b + ',.5);                }                .jgallery[data-jgallery-id="' + this.intId + '"] .change-album .menu {                  background: rgb(' + d.r + ',' + d.g + ', ' + d.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .zoom-container .nav-bottom .change-album > .title {                  background: rgb(' + d.r + ',' + d.g + ', ' + d.b + ');                  box-shadow: 4px 0 4px rgb(' + d.r + ',' + d.g + ', ' + d.b + ')                }                .jgallery[data-jgallery-id="' + this.intId + '"] .full-screen .change-album .menu {                  background: rgb(' + c.r + ',' + c.g + ', ' + c.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .change-album .menu .item {                  border-color: rgb(' + c.r + ',' + c.g + ', ' + c.b + ');                  color: rgb(' + b.r + ',' + b.g + ', ' + b.b + ');                  background: rgb(' + d.r + ',' + d.g + ', ' + d.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .full-screen .change-album .menu .item {                  border-color: rgb(' + d.r + ',' + d.g + ', ' + d.b + ');                  background: rgb(' + c.r + ',' + c.g + ', ' + c.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .change-album .menu .item.active,                .jgallery[data-jgallery-id="' + this.intId + '"] .change-album .menu .item:hover {                  background: rgb(' + b.r + ',' + b.g + ', ' + b.b + ');                  color: rgb(' + c.r + ',' + c.g + ', ' + c.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .zoom-container:not([data-size="fill"]) .jgallery-container {                  background: rgb(' + c.r + ',' + c.g + ', ' + c.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .zoom-container .nav-bottom {                  background: rgb(' + d.r + ',' + d.g + ', ' + d.b + ');                  -webkit-box-shadow: 0 -3px rgba(' + d.r + ',' + d.g + ', ' + d.b + ', .5);                  box-shadow: 0 -3px rgba(' + d.r + ',' + d.g + ', ' + d.b + ', .5);                }                .jgallery[data-jgallery-id="' + this.intId + '"] .zoom-container .nav-bottom .icons,                .jgallery[data-jgallery-id="' + this.intId + '"] .zoom-container .nav-bottom .icons .fa {                  background: rgb(' + d.r + ',' + d.g + ', ' + d.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .zoom-container .nav-bottom > .title {                  color: rgb(' + b.r + ',' + b.g + ', ' + b.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .zoom-container .nav-bottom > .title.expanded {                  background: rgba(' + c.r + ',' + c.g + ', ' + c.b + ',.7);                }                .jgallery[data-jgallery-id="' + this.intId + '"] .zoom-container .drag-nav {                  background: rgb(' + d.r + ',' + d.g + ', ' + d.b + ');                  -webkit-box-shadow: 0 0 0 3px rgba(' + d.r + ',' + d.g + ', ' + d.b + ', .5);                  box-shadow: 0 0 0 3px rgba(' + d.r + ',' + d.g + ', ' + d.b + ', .5);                }                .jgallery[data-jgallery-id="' + this.intId + '"] .zoom-container .drag-nav .crop {                  -webkit-box-shadow: 0 0 0 3px rgba(' + b.r + ',' + b.g + ', ' + b.b + ', .5);                  box-shadow: 0 0 0 3px rgba(' + b.r + ',' + b.g + ', ' + b.b + ', .5);                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-thumbnails {                  background: rgb(' + d.r + ',' + d.g + ', ' + d.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-thumbnails .ico {                  color: rgb(' + b.r + ',' + b.g + ', ' + b.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-thumbnails .jgallery-container {                  -webkit-box-shadow: 0 0 0 3px rgba(' + d.r + ',' + d.g + ', ' + d.b + ', .5);                  box-shadow: 0 0 0 3px rgba(' + d.r + ',' + d.g + ', ' + d.b + ', .5);                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-thumbnails.full-screen .prev:before {                  background-image: -webkit-gradient(linear,left 0%,left 100%,from(rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 )),to(rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0)));                  background-image: -webkit-linear-gradient(top,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 ),0%,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0),100%);                  background-image: -moz-linear-gradient(top,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 ) 0%,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0) 100%);                  background-image: linear-gradient(to bottom,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 ) 0%,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0) 100%);                  background-repeat: repeat-x;                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-thumbnails.full-screen .next:before {                  background-image: -webkit-gradient(linear,left 0%,left 100%,from(rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0)),to(rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1)));                  background-image: -webkit-linear-gradient(top,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0),0%,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1),100%);                  background-image: -moz-linear-gradient(top,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0) 0%,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1) 100%);                  background-image: linear-gradient(to bottom,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0) 0%,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1) 100%);                  background-repeat: repeat-x;                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-thumbnails.images a:after {                  background: rgb(' + d.r + ',' + d.g + ', ' + d.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-thumbnails.full-screen .prev,                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-thumbnails.full-screen .next {                  background: rgb(' + d.r + ',' + d.g + ', ' + d.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-thumbnails.square:not(.full-screen) a {                  background: rgb(' + b.r + ',' + b.g + ', ' + b.b + ');                  color: rgb(' + c.r + ',' + c.g + ', ' + c.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .overlayContainer .overlay {                  background: rgba(' + c.r + ',' + c.g + ', ' + c.b + ',.8);                  color: rgb(' + b.r + ',' + b.g + ', ' + b.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .overlayContainer .imageLoaderPositionAbsolute:after {                  border-color: rgba(' + b.r + ',' + b.g + ', ' + b.b + ', .5 );                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-thumbnails .overlayContainer .overlay {                  background: rgb(' + d.r + ',' + d.g + ', ' + d.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-thumbnails-horizontal .prev {                  background: rgb(' + d.r + ',' + d.g + ', ' + d.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-thumbnails-horizontal .prev:before {                  background-image: -webkit-gradient(linear,0% top,100% top,from(rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 )),to(rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0 )));                  background-image: -webkit-linear-gradient(left,color-stop(rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 ) 0%),color-stop(rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0 ) 100%));                  background-image: -moz-linear-gradient(left,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 ) 0%,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0 ) 100%);                  background-image: linear-gradient(to right,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 ) 0%,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0 ) 100%);                  background-repeat: repeat-x;                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-thumbnails-horizontal .next {                  background: rgb(' + d.r + ',' + d.g + ', ' + d.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-thumbnails-horizontal .next:before {                  background-image: -webkit-gradient(linear,0% top,100% top,from(rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0 )),to(rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 )));                  background-image: -webkit-linear-gradient(left,color-stop(rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0 ) 0%),color-stop(rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 ) 100%));                  background-image: -moz-linear-gradient(left,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0 ) 0%,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 ) 100%);                  background-image: linear-gradient(to right,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0 ) 0%,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 ) 100%);                  background-repeat: repeat-x;                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-thumbnails-vertical .prev {                  background: rgb(' + d.r + ',' + d.g + ', ' + d.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-thumbnails-vertical .prev:before {                  background-image: -webkit-gradient(linear,left 0%,left 100%,from(rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 )),to(rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0 )));                  background-image: -webkit-linear-gradient(top,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 ),0%,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0 ),100%);                  background-image: -moz-linear-gradient(top,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 ) 0%,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0 ) 100%);                  background-image: linear-gradient(to bottom,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 ) 0%,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0 ) 100%);                  background-repeat: repeat-x;                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-thumbnails-vertical .next {                  background: rgb(' + d.r + ',' + d.g + ', ' + d.b + ');                }                .jgallery[data-jgallery-id="' + this.intId + '"] .jgallery-thumbnails-vertical .next:before {                  background-image: -webkit-gradient(linear,left 0%,left 100%,from(rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0 )),to(rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 )));                  background-image: -webkit-linear-gradient(top,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0 ),0%,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 ),100%);                  background-image: -moz-linear-gradient(top,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0 ) 0%,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 ) 100%);                  background-image: linear-gradient(to bottom,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 0 ) 0%,rgba( ' + d.r + ',' + d.g + ', ' + d.b + ', 1 ) 100%);                  background-repeat: repeat-x;                }                .jgallery.jgallery-slider[data-jgallery-id="' + this.intId + '"] .zoom-container .nav-bottom,                .jgallery.jgallery-slider[data-jgallery-id="' + this.intId + '"] .zoom-container .nav-bottom > .title.expanded {                  background: none;                }                .jgallery.has-title.jgallery-slider[data-jgallery-id="' + this.intId + '"] .zoom-container .nav-bottom,                .jgallery.has-title.jgallery-slider[data-jgallery-id="' + this.intId + '"] .zoom-container .nav-bottom > .title.expanded {                  background: rgba(' + c.r + ',' + c.g + ', ' + c.b + ',.7);                  color: rgb(' + b.r + ',' + b.g + ', ' + b.b + ');                }                .jgallery.jgallery-slider[data-jgallery-id="' + this.intId + '"] .zoom-container .nav-bottom .jgallery-btn {                  background: rgba(' + c.r + ',' + c.g + ', ' + c.b + ',.8);                  color: rgb(' + b.r + ',' + b.g + ', ' + b.b + ');                }            ';
      } }, u;
  }(i, l, m, n, o, a, b, c, d, e, q, r, t, u, v);!function (a, b, c, d) {
    var e = [''],
        f = jQuery,
        g = f('html'),
        h = 0;f.fn.jGallery = function (i) {
      var j = this;return this.each(function () {
        var a = f(this);a.is('[data-jgallery-id]') ? f.isPlainObject(i) && e[a.attr('data-jgallery-id')].update(i) : e[++h] = new d(a, h, i);
      }), f.extend(j, { getDefaults: function getDefaults() {
          return b;
        }, getTransitions: function getTransitions() {
          return c;
        }, restoreDefaults: function restoreDefaults() {
          return j.each(function () {
            f(this).jGallery(b);
          });
        }, getOptions: function getOptions() {
          return e[f(j).eq(0).attr('data-jgallery-id')].options;
        }, destroy: function destroy() {
          return j.each(function () {
            var b = f(this),
                c = b.attr('data-jgallery-id');e[c] = '', b.removeAttr('data-jgallery-id').show(), g.find('.jgallery[data-jgallery-id="' + c + '"]').remove(), a();
          });
        } }), this;
    };
  }(o, a, f, w);
}();

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (a) {
  if ("function" === 'function' && __webpack_require__(2) && __webpack_require__(2).jQuery) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    a(jQuery);
  }
})(function (f) {
  var y = '1.6.9',
      p = 'left',
      o = 'right',
      e = 'up',
      x = 'down',
      c = 'in',
      A = 'out',
      m = 'none',
      s = 'auto',
      l = 'swipe',
      t = 'pinch',
      B = 'tap',
      j = 'doubletap',
      b = 'longtap',
      z = 'hold',
      E = 'horizontal',
      u = 'vertical',
      i = 'all',
      r = 10,
      g = 'start',
      k = 'move',
      h = 'end',
      q = 'cancel',
      a = 'ontouchstart' in window,
      v = window.navigator.msPointerEnabled && !window.navigator.pointerEnabled,
      d = window.navigator.pointerEnabled || window.navigator.msPointerEnabled,
      C = 'TouchSwipe';var n = { fingers: 1, threshold: 75, cancelThreshold: null, pinchThreshold: 20, maxTimeThreshold: null, fingerReleaseThreshold: 250, longTapThreshold: 500, doubleTapThreshold: 200, swipe: null, swipeLeft: null, swipeRight: null, swipeUp: null, swipeDown: null, swipeStatus: null, pinchIn: null, pinchOut: null, pinchStatus: null, click: null, tap: null, doubleTap: null, longTap: null, hold: null, triggerOnTouchEnd: true, triggerOnTouchLeave: false, allowPageScroll: 'auto', fallbackToMouseEvents: true, excludedElements: 'label, button, input, select, textarea, a, .noSwipe', preventDefaultEvents: true };f.fn.swipe = function (H) {
    var G = f(this),
        F = G.data(C);if (F && typeof H === 'string') {
      if (F[H]) {
        return F[H].apply(this, Array.prototype.slice.call(arguments, 1));
      } else {
        f.error('Method ' + H + ' does not exist on jQuery.swipe');
      }
    } else {
      if (!F && ((typeof H === 'undefined' ? 'undefined' : _typeof(H)) === 'object' || !H)) {
        return w.apply(this, arguments);
      }
    }return G;
  };f.fn.swipe.version = y;f.fn.swipe.defaults = n;f.fn.swipe.phases = { PHASE_START: g, PHASE_MOVE: k, PHASE_END: h, PHASE_CANCEL: q };f.fn.swipe.directions = { LEFT: p, RIGHT: o, UP: e, DOWN: x, IN: c, OUT: A };f.fn.swipe.pageScroll = { NONE: m, HORIZONTAL: E, VERTICAL: u, AUTO: s };f.fn.swipe.fingers = { ONE: 1, TWO: 2, THREE: 3, ALL: i };function w(F) {
    if (F && F.allowPageScroll === undefined && (F.swipe !== undefined || F.swipeStatus !== undefined)) {
      F.allowPageScroll = m;
    }if (F.click !== undefined && F.tap === undefined) {
      F.tap = F.click;
    }if (!F) {
      F = {};
    }F = f.extend({}, f.fn.swipe.defaults, F);return this.each(function () {
      var H = f(this);var G = H.data(C);if (!G) {
        G = new D(this, F);H.data(C, G);
      }
    });
  }function D(a5, aw) {
    var aA = a || d || !aw.fallbackToMouseEvents,
        K = aA ? d ? v ? 'MSPointerDown' : 'pointerdown' : 'touchstart' : 'mousedown',
        az = aA ? d ? v ? 'MSPointerMove' : 'pointermove' : 'touchmove' : 'mousemove',
        V = aA ? d ? v ? 'MSPointerUp' : 'pointerup' : 'touchend' : 'mouseup',
        T = aA ? null : 'mouseleave',
        aE = d ? v ? 'MSPointerCancel' : 'pointercancel' : 'touchcancel';var ah = 0,
        aQ = null,
        ac = 0,
        a2 = 0,
        a0 = 0,
        H = 1,
        ar = 0,
        aK = 0,
        N = null;var aS = f(a5);var aa = 'start';var X = 0;var aR = null;var U = 0,
        a3 = 0,
        a6 = 0,
        ae = 0,
        O = 0;var aX = null,
        ag = null;try {
      aS.bind(K, aO);aS.bind(aE, ba);
    } catch (al) {
      f.error('events not supported ' + K + ',' + aE + ' on jQuery.swipe');
    }this.enable = function () {
      aS.bind(K, aO);aS.bind(aE, ba);return aS;
    };this.disable = function () {
      aL();return aS;
    };this.destroy = function () {
      aL();aS.data(C, null);aS = null;
    };this.option = function (bd, bc) {
      if (aw[bd] !== undefined) {
        if (bc === undefined) {
          return aw[bd];
        } else {
          aw[bd] = bc;
        }
      } else {
        f.error('Option ' + bd + ' does not exist on jQuery.swipe.options');
      }return null;
    };function aO(be) {
      if (aC()) {
        return;
      }if (f(be.target).closest(aw.excludedElements, aS).length > 0) {
        return;
      }var bf = be.originalEvent ? be.originalEvent : be;var bd,
          bg = bf.touches,
          bc = bg ? bg[0] : bf;aa = g;if (bg) {
        X = bg.length;
      } else {
        be.preventDefault();
      }ah = 0;aQ = null;aK = null;ac = 0;a2 = 0;a0 = 0;H = 1;ar = 0;aR = ak();N = ab();S();if (!bg || X === aw.fingers || aw.fingers === i || aY()) {
        aj(0, bc);U = au();if (X == 2) {
          aj(1, bg[1]);a2 = a0 = av(aR[0].start, aR[1].start);
        }if (aw.swipeStatus || aw.pinchStatus) {
          bd = P(bf, aa);
        }
      } else {
        bd = false;
      }if (bd === false) {
        aa = q;P(bf, aa);return bd;
      } else {
        if (aw.hold) {
          ag = setTimeout(f.proxy(function () {
            aS.trigger('hold', [bf.target]);if (aw.hold) {
              bd = aw.hold.call(aS, bf, bf.target);
            }
          }, this), aw.longTapThreshold);
        }ap(true);
      }return null;
    }function a4(bf) {
      var bi = bf.originalEvent ? bf.originalEvent : bf;if (aa === h || aa === q || an()) {
        return;
      }var be,
          bj = bi.touches,
          bd = bj ? bj[0] : bi;var bg = aI(bd);a3 = au();if (bj) {
        X = bj.length;
      }if (aw.hold) {
        clearTimeout(ag);
      }aa = k;if (X == 2) {
        if (a2 == 0) {
          aj(1, bj[1]);a2 = a0 = av(aR[0].start, aR[1].start);
        } else {
          aI(bj[1]);a0 = av(aR[0].end, aR[1].end);aK = at(aR[0].end, aR[1].end);
        }H = a8(a2, a0);ar = Math.abs(a2 - a0);
      }if (X === aw.fingers || aw.fingers === i || !bj || aY()) {
        aQ = aM(bg.start, bg.end);am(bf, aQ);ah = aT(bg.start, bg.end);ac = aN();aJ(aQ, ah);if (aw.swipeStatus || aw.pinchStatus) {
          be = P(bi, aa);
        }if (!aw.triggerOnTouchEnd || aw.triggerOnTouchLeave) {
          var bc = true;if (aw.triggerOnTouchLeave) {
            var bh = aZ(this);bc = F(bg.end, bh);
          }if (!aw.triggerOnTouchEnd && bc) {
            aa = aD(k);
          } else {
            if (aw.triggerOnTouchLeave && !bc) {
              aa = aD(h);
            }
          }if (aa == q || aa == h) {
            P(bi, aa);
          }
        }
      } else {
        aa = q;P(bi, aa);
      }if (be === false) {
        aa = q;P(bi, aa);
      }
    }function M(bc) {
      var bd = bc.originalEvent ? bc.originalEvent : bc,
          be = bd.touches;if (be) {
        if (be.length) {
          G();return true;
        }
      }if (an()) {
        X = ae;
      }a3 = au();ac = aN();if (bb() || !ao()) {
        aa = q;P(bd, aa);
      } else {
        if (aw.triggerOnTouchEnd || aw.triggerOnTouchEnd == false && aa === k) {
          bc.preventDefault();aa = h;P(bd, aa);
        } else {
          if (!aw.triggerOnTouchEnd && a7()) {
            aa = h;aG(bd, aa, B);
          } else {
            if (aa === k) {
              aa = q;P(bd, aa);
            }
          }
        }
      }ap(false);return null;
    }function ba() {
      X = 0;a3 = 0;U = 0;a2 = 0;a0 = 0;H = 1;S();ap(false);
    }function L(bc) {
      var bd = bc.originalEvent ? bc.originalEvent : bc;if (aw.triggerOnTouchLeave) {
        aa = aD(h);P(bd, aa);
      }
    }function aL() {
      aS.unbind(K, aO);aS.unbind(aE, ba);aS.unbind(az, a4);aS.unbind(V, M);if (T) {
        aS.unbind(T, L);
      }ap(false);
    }function aD(bg) {
      var bf = bg;var be = aB();var bd = ao();var bc = bb();if (!be || bc) {
        bf = q;
      } else {
        if (bd && bg == k && (!aw.triggerOnTouchEnd || aw.triggerOnTouchLeave)) {
          bf = h;
        } else {
          if (!bd && bg == h && aw.triggerOnTouchLeave) {
            bf = q;
          }
        }
      }return bf;
    }function P(be, bc) {
      var bd,
          bf = be.touches;if (J() || W() || Q() || aY()) {
        if (J() || W()) {
          bd = aG(be, bc, l);
        }if ((Q() || aY()) && bd !== false) {
          bd = aG(be, bc, t);
        }
      } else {
        if (aH() && bd !== false) {
          bd = aG(be, bc, j);
        } else {
          if (aq() && bd !== false) {
            bd = aG(be, bc, b);
          } else {
            if (ai() && bd !== false) {
              bd = aG(be, bc, B);
            }
          }
        }
      }if (bc === q) {
        ba(be);
      }if (bc === h) {
        if (bf) {
          if (!bf.length) {
            ba(be);
          }
        } else {
          ba(be);
        }
      }return bd;
    }function aG(bf, bc, be) {
      var bd;if (be == l) {
        aS.trigger('swipeStatus', [bc, aQ || null, ah || 0, ac || 0, X, aR]);if (aw.swipeStatus) {
          bd = aw.swipeStatus.call(aS, bf, bc, aQ || null, ah || 0, ac || 0, X, aR);if (bd === false) {
            return false;
          }
        }if (bc == h && aW()) {
          aS.trigger('swipe', [aQ, ah, ac, X, aR]);if (aw.swipe) {
            bd = aw.swipe.call(aS, bf, aQ, ah, ac, X, aR);if (bd === false) {
              return false;
            }
          }switch (aQ) {case p:
              aS.trigger('swipeLeft', [aQ, ah, ac, X, aR]);if (aw.swipeLeft) {
                bd = aw.swipeLeft.call(aS, bf, aQ, ah, ac, X, aR);
              }break;case o:
              aS.trigger('swipeRight', [aQ, ah, ac, X, aR]);if (aw.swipeRight) {
                bd = aw.swipeRight.call(aS, bf, aQ, ah, ac, X, aR);
              }break;case e:
              aS.trigger('swipeUp', [aQ, ah, ac, X, aR]);if (aw.swipeUp) {
                bd = aw.swipeUp.call(aS, bf, aQ, ah, ac, X, aR);
              }break;case x:
              aS.trigger('swipeDown', [aQ, ah, ac, X, aR]);if (aw.swipeDown) {
                bd = aw.swipeDown.call(aS, bf, aQ, ah, ac, X, aR);
              }break;}
        }
      }if (be == t) {
        aS.trigger('pinchStatus', [bc, aK || null, ar || 0, ac || 0, X, H, aR]);if (aw.pinchStatus) {
          bd = aw.pinchStatus.call(aS, bf, bc, aK || null, ar || 0, ac || 0, X, H, aR);if (bd === false) {
            return false;
          }
        }if (bc == h && a9()) {
          switch (aK) {case c:
              aS.trigger('pinchIn', [aK || null, ar || 0, ac || 0, X, H, aR]);if (aw.pinchIn) {
                bd = aw.pinchIn.call(aS, bf, aK || null, ar || 0, ac || 0, X, H, aR);
              }break;case A:
              aS.trigger('pinchOut', [aK || null, ar || 0, ac || 0, X, H, aR]);if (aw.pinchOut) {
                bd = aw.pinchOut.call(aS, bf, aK || null, ar || 0, ac || 0, X, H, aR);
              }break;}
        }
      }if (be == B) {
        if (bc === q || bc === h) {
          clearTimeout(aX);clearTimeout(ag);if (Z() && !I()) {
            O = au();aX = setTimeout(f.proxy(function () {
              O = null;aS.trigger('tap', [bf.target]);if (aw.tap) {
                bd = aw.tap.call(aS, bf, bf.target);
              }
            }, this), aw.doubleTapThreshold);
          } else {
            O = null;aS.trigger('tap', [bf.target]);if (aw.tap) {
              bd = aw.tap.call(aS, bf, bf.target);
            }
          }
        }
      } else {
        if (be == j) {
          if (bc === q || bc === h) {
            clearTimeout(aX);O = null;aS.trigger('doubletap', [bf.target]);if (aw.doubleTap) {
              bd = aw.doubleTap.call(aS, bf, bf.target);
            }
          }
        } else {
          if (be == b) {
            if (bc === q || bc === h) {
              clearTimeout(aX);O = null;aS.trigger('longtap', [bf.target]);if (aw.longTap) {
                bd = aw.longTap.call(aS, bf, bf.target);
              }
            }
          }
        }
      }return bd;
    }function ao() {
      var bc = true;if (aw.threshold !== null) {
        bc = ah >= aw.threshold;
      }return bc;
    }function bb() {
      var bc = false;if (aw.cancelThreshold !== null && aQ !== null) {
        bc = aU(aQ) - ah >= aw.cancelThreshold;
      }return bc;
    }function af() {
      if (aw.pinchThreshold !== null) {
        return ar >= aw.pinchThreshold;
      }return true;
    }function aB() {
      var bc;if (aw.maxTimeThreshold) {
        if (ac >= aw.maxTimeThreshold) {
          bc = false;
        } else {
          bc = true;
        }
      } else {
        bc = true;
      }return bc;
    }function am(bc, bd) {
      if (aw.preventDefaultEvents === false) {
        return;
      }if (aw.allowPageScroll === m) {
        bc.preventDefault();
      } else {
        var be = aw.allowPageScroll === s;switch (bd) {case p:
            if (aw.swipeLeft && be || !be && aw.allowPageScroll != E) {
              bc.preventDefault();
            }break;case o:
            if (aw.swipeRight && be || !be && aw.allowPageScroll != E) {
              bc.preventDefault();
            }break;case e:
            if (aw.swipeUp && be || !be && aw.allowPageScroll != u) {
              bc.preventDefault();
            }break;case x:
            if (aw.swipeDown && be || !be && aw.allowPageScroll != u) {
              bc.preventDefault();
            }break;}
      }
    }function a9() {
      var bd = aP();var bc = Y();var be = af();return bd && bc && be;
    }function aY() {
      return !!(aw.pinchStatus || aw.pinchIn || aw.pinchOut);
    }function Q() {
      return !!(a9() && aY());
    }function aW() {
      var bf = aB();var bh = ao();var be = aP();var bc = Y();var bd = bb();var bg = !bd && bc && be && bh && bf;return bg;
    }function W() {
      return !!(aw.swipe || aw.swipeStatus || aw.swipeLeft || aw.swipeRight || aw.swipeUp || aw.swipeDown);
    }function J() {
      return !!(aW() && W());
    }function aP() {
      return X === aw.fingers || aw.fingers === i || !a;
    }function Y() {
      return aR[0].end.x !== 0;
    }function a7() {
      return !!aw.tap;
    }function Z() {
      return !!aw.doubleTap;
    }function aV() {
      return !!aw.longTap;
    }function R() {
      if (O == null) {
        return false;
      }var bc = au();return Z() && bc - O <= aw.doubleTapThreshold;
    }function I() {
      return R();
    }function ay() {
      return (X === 1 || !a) && (isNaN(ah) || ah < aw.threshold);
    }function a1() {
      return ac > aw.longTapThreshold && ah < r;
    }function ai() {
      return !!(ay() && a7());
    }function aH() {
      return !!(R() && Z());
    }function aq() {
      return !!(a1() && aV());
    }function G() {
      a6 = au();ae = event.touches.length + 1;
    }function S() {
      a6 = 0;ae = 0;
    }function an() {
      var bc = false;if (a6) {
        var bd = au() - a6;if (bd <= aw.fingerReleaseThreshold) {
          bc = true;
        }
      }return bc;
    }function aC() {
      return !!(aS.data(C + '_intouch') === true);
    }function ap(bc) {
      if (bc === true) {
        aS.bind(az, a4);aS.bind(V, M);if (T) {
          aS.bind(T, L);
        }
      } else {
        aS.unbind(az, a4, false);aS.unbind(V, M, false);if (T) {
          aS.unbind(T, L, false);
        }
      }aS.data(C + '_intouch', bc === true);
    }function aj(bd, bc) {
      var be = bc.identifier !== undefined ? bc.identifier : 0;aR[bd].identifier = be;aR[bd].start.x = aR[bd].end.x = bc.pageX || bc.clientX;aR[bd].start.y = aR[bd].end.y = bc.pageY || bc.clientY;return aR[bd];
    }function aI(bc) {
      var be = bc.identifier !== undefined ? bc.identifier : 0;var bd = ad(be);bd.end.x = bc.pageX || bc.clientX;bd.end.y = bc.pageY || bc.clientY;return bd;
    }function ad(bd) {
      for (var bc = 0; bc < aR.length; bc++) {
        if (aR[bc].identifier == bd) {
          return aR[bc];
        }
      }
    }function ak() {
      var bc = [];for (var bd = 0; bd <= 5; bd++) {
        bc.push({ start: { x: 0, y: 0 }, end: { x: 0, y: 0 }, identifier: 0 });
      }return bc;
    }function aJ(bc, bd) {
      bd = Math.max(bd, aU(bc));N[bc].distance = bd;
    }function aU(bc) {
      if (N[bc]) {
        return N[bc].distance;
      }return undefined;
    }function ab() {
      var bc = {};bc[p] = ax(p);bc[o] = ax(o);bc[e] = ax(e);bc[x] = ax(x);return bc;
    }function ax(bc) {
      return { direction: bc, distance: 0 };
    }function aN() {
      return a3 - U;
    }function av(bf, be) {
      var bd = Math.abs(bf.x - be.x);var bc = Math.abs(bf.y - be.y);return Math.round(Math.sqrt(bd * bd + bc * bc));
    }function a8(bc, bd) {
      var be = bd / bc * 1;return be.toFixed(2);
    }function at() {
      if (H < 1) {
        return A;
      } else {
        return c;
      }
    }function aT(bd, bc) {
      return Math.round(Math.sqrt(Math.pow(bc.x - bd.x, 2) + Math.pow(bc.y - bd.y, 2)));
    }function aF(bf, bd) {
      var bc = bf.x - bd.x;var bh = bd.y - bf.y;var be = Math.atan2(bh, bc);var bg = Math.round(be * 180 / Math.PI);if (bg < 0) {
        bg = 360 - Math.abs(bg);
      }return bg;
    }function aM(bd, bc) {
      var be = aF(bd, bc);if (be <= 45 && be >= 0) {
        return p;
      } else {
        if (be <= 360 && be >= 315) {
          return p;
        } else {
          if (be >= 135 && be <= 225) {
            return o;
          } else {
            if (be > 45 && be < 135) {
              return x;
            } else {
              return e;
            }
          }
        }
      }
    }function au() {
      var bc = new Date();return bc.getTime();
    }function aZ(bc) {
      bc = f(bc);var be = bc.offset();var bd = { left: be.left, right: be.left + bc.outerWidth(), top: be.top, bottom: be.top + bc.outerHeight() };return bd;
    }function F(bc, bd) {
      return bc.x > bd.left && bc.x < bd.right && bc.y > bd.top && bc.y < bd.bottom;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = __webpack_require__(0);
'use strict';
///*------------------------------------------
///* всплывающая форма при заказе консультации   
///*------------------------------------------
var openModalForm = function openModalForm() {
  $('.open-modalf').on('click', function (e) {
    e.preventDefault();
    var dataService = $(this).attr('data-service');
    $('input#hidden-form').val(dataService);
    $('.popup-f, .overlay-f').css({ 'opacity': '1', 'visibility': 'visible' });
    $('.popup-f .close-modal').click(function () {
      $('.popup-f, .popup2, .overlay-f').css({ 'opacity': '0', 'visibility': 'hidden' });
      $('.popup-f > .fofm textarea').val('');
      $(':input', '.fofm').not(':button, :submit, :reset, :hidden').val('').removeAttr('checked').removeAttr('selected');
    });
  });
};
exports.default = openModalForm;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var $ = __webpack_require__(0);
'use strict';
///*------------------------------------------
///* всплывающая форма при заказе консультации   
///*------------------------------------------
var formPopupHandler = function formPopupHandler() {
	$(document).on('change', '#formService input[name="valTrFal"]', function () {
		if ($(this).val() === "valTrFal_true") {
			$(".fofm button[type=submit]").removeAttr('disabled');
			$('.fofm input[type=hidden].valTrFal').val('valTrFal_true');
		} else {
			$(".fofm button[type=submit]").attr('disabled', 'disabled');
			$('.fofm input[type=hidden].valTrFal').val('valTrFal_disabled');
		}
	});

	$("#formService").submit(function () {
		if ($('#formService input[name="valTrFal"]').val() !== "valTrFal_true") {
			$(".fofm button[type=submit]").attr('disabled', 'disabled');
			$('.fofm input[type=hidden].valTrFal').val('valTrFal_disabled');
		}
		var data = $(this).serialize();
		$.ajax({
			type: "POST",
			url: "php/contact.php",
			data: data,
			success: function success(msg) {
				if (msg == 'ok') {
					$('.popup2, .overlay-f').css('opacity', '1');
					$('.popup2, .overlay-f').css('visibility', 'visible');
					$('.popup-f').css({ 'opacity': '0', 'visibility': 'hidden' });
					$('#order-calculation textarea').val('');
					$(':input', '#order-calculation').not(':button, :submit, :reset, :hidden').val('').removeAttr('checked').removeAttr('selected');
					$('.popup2 .close-modal').click(function () {
						$('.popup-f, .popup2, .overlay-f').css({ 'opacity': '0', 'visibility': 'hidden' });
					});
				} else {
					$('.popup2 .window').html('<div class="insText"><h3 class="insText__title">Ошибка</h3><div class="insText__text">Сообщение не отправлено, убедитесь в правильности заполнения полей.</div></div>');
					$('.popup2, .overlay-f').css('opacity', '1');
					$('.popup2, .overlay-f').css('visibility', 'visible');
					$('.popup-f').css({ 'opacity': '0', 'visibility': 'hidden' });
					$('#order-calculation textarea').val('');
					$(':input', '#formService').not(':button, :submit, :reset, :hidden').val('').removeAttr('checked').removeAttr('selected');
					$('.popup2 .close-modal').click(function () {
						$('.popup-f, .popup2, .overlay-f').css({ 'opacity': '0', 'visibility': 'hidden' });
					});
				}
			}
		});
		return false;
	});
};
exports.default = formPopupHandler;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var $ = __webpack_require__(0);
'use strict';
///*------------------------------------------
///*  заказ газона   
///*------------------------------------------
var formGazonHandler = function formGazonHandler() {
	$(document).on('change', '#order-calculation input[name="valTrFal"]', function () {
		if ($(this).val() === "valTrFal_true") {
			$("#order-calculation button[type=submit]").removeAttr('disabled');
			$('#order-calculation input[type=hidden].valTrFal').val('valTrFal_true');
		} else {
			$("#order-calculation button[type=submit]").attr('disabled', 'disabled');
			$('#order-calculation input[type=hidden].valTrFal').val('valTrFal_disabled');
		}
	});

	$("#order-calculation").submit(function () {
		if ($('#order-calculation input[name="valTrFal"]').val() !== "valTrFal_true") {
			$("#order-calculation button[type=submit]").attr('disabled', 'disabled');
			$('#order-calculation input[type=hidden].valTrFal').val('valTrFal_disabled');
		}
		var data = $(this).serialize();
		$.ajax({
			type: "POST",
			url: "php/gazon.php",
			data: data,
			success: function success(msg) {
				if (msg == 'ok') {
					$('.popup2, .overlay-f').css('opacity', '1');
					$('.popup2, .overlay-f').css('visibility', 'visible');
					$('.popup-f').css({ 'opacity': '0', 'visibility': 'hidden' });
					$('#order-calculation textarea').val('');
					$(':input', '#order-calculation').not(':button, :submit, :reset, :hidden').val('').removeAttr('checked').removeAttr('selected');
					$('.popup2 .close-modal').click(function () {
						$('.popup-f, .popup2, .overlay-f').css({ 'opacity': '0', 'visibility': 'hidden' });
					});
				} else {
					$('.popup2 .window').html('<div class="insText"><h3 class="insText__title">Ошибка</h3><div class="insText__text">Сообщение не отправлено, убедитесь в правильности заполнения полей.</div></div>');
					$('.popup2, .overlay-f').css('opacity', '1');
					$('.popup2, .overlay-f').css('visibility', 'visible');
					$('.popup-f').css({ 'opacity': '0', 'visibility': 'hidden' });
					$('#order-calculation textarea').val('');
					$(':input', '#order-calculation').not(':button, :submit, :reset, :hidden').val('').removeAttr('checked').removeAttr('selected');
					$('.popup2 .close-modal').click(function () {
						$('.popup-f, .popup2, .overlay-f').css({ 'opacity': '0', 'visibility': 'hidden' });
					});
				}
			}
		});
		return false;
	});
};
exports.default = formGazonHandler;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var $ = __webpack_require__(0);
'use strict';
///*------------------------------------------
///*  заказ проекта 
///*------------------------------------------
var formProjectHandler = function formProjectHandler() {
	$(document).on('change', '#orderCall input[name="valTrFal"]', function () {
		if ($(this).val() === "valTrFal_true") {
			$("#orderCall button[type=submit]").removeAttr('disabled');
			$('#orderCall input[type=hidden].valTrFal').val('valTrFal_true');
		} else {
			$("#orderCall button[type=submit]").attr('disabled', 'disabled');
			$('#orderCall input[type=hidden].valTrFal').val('valTrFal_disabled');
		}
	});

	$("#orderCall").submit(function () {
		if ($('#orderCall input[name="valTrFal"]').val() !== "valTrFal_true") {
			$("#orderCall button[type=submit]").attr('disabled', 'disabled');
			$('#orderCall input[type=hidden].valTrFal').val('valTrFal_disabled');
		}
		var data = $(this).serialize();
		$.ajax({
			type: "POST",
			url: "php/project.php",
			data: data,
			success: function success(msg) {
				if (msg == 'ok') {
					$('.popup2, .overlay-f').css('opacity', '1');
					$('.popup2, .overlay-f').css('visibility', 'visible');
					$('.popup-f').css({ 'opacity': '0', 'visibility': 'hidden' });
					$('#orderCall textarea').val('');
					$(':input', '#orderCall').not(':button, :submit, :reset, :hidden').val('').removeAttr('checked').removeAttr('selected');
					$('.popup2 .close-modal').click(function () {
						$('.popup-f, .popup2, .overlay-f').css({ 'opacity': '0', 'visibility': 'hidden' });
					});
				} else {
					$('.popup2 .window').html('<div class="insText"><h3 class="insText__title">Ошибка</h3><div class="insText__text">Сообщение не отправлено, убедитесь в правильности заполнения полей.</div></div>');
					$('.popup2, .overlay-f').css('opacity', '1');
					$('.popup2, .overlay-f').css('visibility', 'visible');
					$('.popup-f').css({ 'opacity': '0', 'visibility': 'hidden' });
					$('#orderCall textarea').val('');
					$(':input', '#orderCall').not(':button, :submit, :reset, :hidden').val('').removeAttr('checked').removeAttr('selected');
					$('.popup2 .close-modal').click(function () {
						$('.popup-f, .popup2, .overlay-f').css({ 'opacity': '0', 'visibility': 'hidden' });
					});
				}
			}
		});
		return false;
	});
};
exports.default = formProjectHandler;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app/index.bundle.js